import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import { getAllowedConfigs, getCurrentUser } from '../../utils/permissions';
import { getCachedConfigsListSync } from '../../utils/configUtils';
import { generateAmountsForTariff } from '../../utils/amountGenerator';
import { logAudit } from '../../utils/audit';
import { getEmailWalletVariables } from '../../utils/walletResolver';
import { notifyError, notifyWarning } from '../../utils/notify';
import {
    Settings, FolderCog, UserRound, Wallet, Coins, Zap, ArrowLeftRight,
    ChevronDown, Plus, Minus, Save, Send, CircleCheckBig, Circle as CircleIcon,
    Banknote, Gem, Flame, Crown, Sparkles,
    Percent, ShieldCheck, ReceiptText, Repeat, Landmark, BellRing, X as XIcon,
    Users, UserPlus, RefreshCw, Replace, ArrowRight, LayoutTemplate, Camera,
} from 'lucide-react';
import s from './AdminPanel.module.sass';
import ConfigPicker from './ConfigPicker';

// Импорт иконок для замены эмодзи
import userInfoIcon from '../../img/iconsas/user_information.png';
import bankConfigIcon from '../../img/iconsas/bank_configuration.png';
import transactionsIcon from '../../img/iconsas/transactions.png';
import customValuesIcon from '../../img/iconsas/custom_values.png';
import commissionModalIcon from '../../img/iconsas/comission_modal.png';
import verificationModalIcon from '../../img/iconsas/verification_modal.png';
import successModalIcon from '../../img/iconsas/success_modal.png';
import taxModalIcon from '../../img/iconsas/tax_modal.png';
import cryptoConversionModalIcon from '../../img/iconsas/crypto_conversion_modal.png';
import bankConversionModalIcon from '../../img/iconsas/bank_conversion_modal.png';
import addButtonIcon from '../../img/iconsas/add_button.png';
import removeButtonIcon from '../../img/iconsas/remove_button.png';
import configIcon from '../../img/iconsas/site_settings.png';
// Тарифы
import tarif1Icon from '../../img/iconsas/1tarif.png';
import tarif2Icon from '../../img/iconsas/2tarif.png';
import tarif3Icon from '../../img/iconsas/3tarif.png';
import tarif4Icon from '../../img/iconsas/4tarif.png';
import viptarifIcon from '../../img/iconsas/viptarif.png';
// Дополнительные иконки
import bitcoinIcon from '../../img/Bitcoin.svg.png';
import ethereumIcon from '../../img/Ethereum-ETH-icon.png';
import binanceIcon from '../../img/binance-coin-bnb-logo-CD94CC6D31-seeklogo.com.png';
import tronIcon from '../../img/tron.png';
import usdcIcon from '../../img/usdclogo.png';
import solanaIcon from '../../img/solana.png';
import quickActionsIcon from '../../img/iconsas/quickactions.png';

// Helper to normalize person names similarly to server
function normalizePersonName(raw){
  try{
    let s = String(raw||'').trim();
    if(!s) return '';
    s = s.replace(/\s+/g,' ');
    const lower = s.toLowerCase();
    const tokens = lower.split(' ');
    const particles = new Set(['bin','binti','ibn','bint','al','el','abu','umm','ummi','bte','bt','abd','de','du','des','del','dels','le','la','les','di','da','dal','dalla','dalle','dello','delle','della','dei','degli','dell','do','dos','da','das','de','del','de','la','de','las','de','los','y','e','i','los','las','lo','das','dos','van','von','der','den','het','ter','ten','te','op','aan','uit','vom','zum','zur','und','im','am','af','av','z','ze','od','u','na','po','nic','ní','ua','uí','o','mhic','ben','bat','bar','e','ye','of','the','and']);
    const result = tokens.map(tok=>{
      if(/^[dl][\'’][a-z]/.test(tok)){
        const pre = tok.slice(0,2);
        const rest = tok.slice(2);
        const cap = rest.split('-').map(seg=> seg? seg[0].toUpperCase()+seg.slice(1):seg).join('-');
        return pre+cap;
      }
      const apoIdx = tok.indexOf("'");
      const apoIdx2 = tok.indexOf('’');
      const idx = apoIdx>=0? apoIdx: apoIdx2;
      if(idx>0 && idx<tok.length-1){
        const pre = tok.slice(0,idx+1);
        const rest = tok.slice(idx+1);
        const cap = rest.split('-').map(seg=> seg? seg[0].toUpperCase()+seg.slice(1):seg).join('-');
        return pre+cap;
      }
      if(particles.has(tok)) return tok;
      return tok.split('-').map(seg=> seg? seg[0].toUpperCase()+seg.slice(1):seg).join('-');
    });
    return result.join(' ');
  }catch(_){ return String(raw||''); }
}

// Память прокрутки контента админки (как у вкладок минифигмы): живёт на
// уровне модуля, поэтому переживает закрытие/открытие панели и смену темы —
// при повторном открытии не нужно крутить сверху
let adminScrollMemory = 0;

export const AdminPanel = ({ 
    adminPanel,
    setAdminPanel,
    anyModalOpen,
    showInBinpanel,
    setShowInBinpanel,
    nameUser,
    setNameUser,
    setConfirmedNameUser,
    confirmedNameUser,
    userEmail,
    setUserEmail,
    cryptoAdress,
    setcryptoAdress,
    networks,
    network,
    setNetwork,
    setNetworkDropdownOpen,
    networkDropdownOpen,
    imgCoin,
    setImgCoin,
    tariffs,
    handleTariffClick,
    setshowVerifyModal,
    setSendingErrorModal,
    setShowModaWithdrawal,
    setshowNalogModal,
    setShowCryptoConversionModal,
    setShowBankConversionModal,
    setShowCodeModal,
    setShowCodeInputModal,
    setShowPremiumModal,
    transactions,
    setTransactions,
    maxTotalMoney,
    customMaxMoney,
    setCustomMaxMoney,
    customDepositMoney,
    setCustomDepositMoney,
    telegram,
    selectedCrypto,
    setSelectedCrypto,
    cryptoOptions,
    currencyFormat,
    siteSettings,
    onApplyConfig,
    currentConfigFile,
    setMaxTotalMoney,
    setDepositMoneyHistory,
    calculateCryptoAmount,
    handleUpdateValues,
    paymentDateTime,
    setPaymentDateTime,
    setVerifyModalAmount,
    setLocalSuccessTxId,
    generateTxId,
    userRole,
    setCurrentUserGeneratedAmounts,
    setCustomModalState
}) => {
    const getAuthHeaders = () => {
        const token = localStorage.getItem('authToken');
        return token ? { Authorization: `Bearer ${token}` } : {};
    };

    // Nova-скин: в теме Nova PNG-иконки заменяются на lucide, панель порталится
    // внутрь Nova-рута (каскад токенов). Классические темы не затрагиваются.
    const isNovaTheme = siteSettings?.theme === 'nova';

    // Иконка заголовка секции: lucide в Nova, старый PNG в классике
    const SectionGlyph = ({ icon: LucideIcon, png, alt }) => (
        isNovaTheme && LucideIcon
            ? <LucideIcon size={14} strokeWidth={2} className={s.sectionGlyph} aria-hidden="true" />
            : <img src={png} alt={alt} className={s.sectionIcon} />
    );

    // Шеврон кнопки сворачивания секции (в классике остаётся текстовый «▾»)
    const CollapseGlyph = ({ open }) => (
        isNovaTheme
            ? <ChevronDown size={15} strokeWidth={2} className={`${s.chev} ${open ? '' : s.chevUp}`} aria-hidden="true" />
            : '▾'
    );

    // Глиф тарифа: цвет наследуется от карточки тарифа (currentColor)
    const TARIFF_GLYPHS = [
        { match: 'VIP', Icon: Crown },
        { match: '1 ТАРИФ', Icon: Coins },
        { match: '2 ТАРИФ', Icon: Banknote },
        { match: '3 ТАРИФ', Icon: Gem },
        { match: '4 ТАРИФ', Icon: Flame },
    ];
    const TariffGlyph = ({ label }) => {
        const found = TARIFF_GLYPHS.find(g => label.includes(g.match));
        const Icon = found ? found.Icon : Coins;
        return <Icon size={16} strokeWidth={2} className={s.tariffGlyph} aria-hidden="true" />;
    };

    // Пунктирная рамка тарифа (Nova): два SVG-контура — штриховой и сплошной.
    // При выборе сплошная линия плавно «обрисовывается» по периметру
    // (анимация stroke-dashoffset, нормированного через pathLength),
    // а штрихи растворяются под ней
    const TariffDashBorder = () => isNovaTheme ? (
        <svg className={s.tariffDash} aria-hidden="true">
            <rect className={s.tariffDashDots} x="0.6" y="0.6" rx="8.4" />
            <rect className={s.tariffDashLine} x="0.6" y="0.6" rx="8.4" pathLength="100" />
        </svg>
    ) : null;

    // Глифы быстрых действий (вместо тёмных PNG из конфига): по ключу действия
    const ACTION_GLYPHS = {
        commission: Percent,
        verification: ShieldCheck,
        success: CircleCheckBig,
        tax: ReceiptText,
        cryptoConversion: Repeat,
        bankConversion: Landmark,
        code: BellRing,
        premium: Crown,
    };
    const ActionGlyph = ({ actionKey }) => {
        const Icon = ACTION_GLYPHS[actionKey] || Sparkles;
        return (
            <span className={s.actionGlyph} aria-hidden="true">
                <Icon size={15} strokeWidth={2} />
            </span>
        );
    };

    // Локальные SVG-иконки (в Nova — lucide для единого стеля иконок)
    const IconSave = ({ size = 16 }) => isNovaTheme
        ? <Save size={size} strokeWidth={2} style={{ verticalAlign: 'middle' }} aria-hidden="true" />
        : (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
            <path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 21V13H7v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 3v6h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
    const IconPlane = ({ size = 16 }) => isNovaTheme
        ? <Send size={size} strokeWidth={2} style={{ verticalAlign: 'middle' }} aria-hidden="true" />
        : (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
            <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
    const IconCheckCircle = ({ size = 14 }) => isNovaTheme
        ? <CircleCheckBig size={size} strokeWidth={2.2} style={{ verticalAlign: 'middle' }} aria-hidden="true" />
        : (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M22 4L12 14.01l-3-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
    const IconCircle = ({ size = 12 }) => isNovaTheme
        ? <CircleIcon size={size} strokeWidth={2.2} style={{ verticalAlign: 'middle' }} aria-hidden="true" />
        : (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
        </svg>
    );
    const [cryptoDropdownOpen, setCryptoDropdownOpen] = useState(false);
    const [configDropdownOpen, setConfigDropdownOpen] = useState(false);
    // Ожидание корня Nova после переключения темы: панель портлируется
    // в [data-nova-theme], и пока корень не смонтирован, рендер отложен
    // (иначе панель появлялась без CSS-токенов темы — «прозрачной»)
    const [, bumpNovaRootCheck] = useState(0);
    // Модал закрывается с анимацией (~200мс), а флаг open гаснет только после
    // неё. Чтобы бэкдроп админки не появлялся с провалом «пустоты», ловим
    // старт закрытия по классу оверлея (overlayOut/overlayClosing) и начинаем
    // возвращать бэкдроп сразу — кросс-фейдом с уходящим модалом
    const [modalLeaving, setModalLeaving] = useState(false);
    useEffect(() => {
        if (!isNovaTheme || !anyModalOpen || typeof document === 'undefined') {
            setModalLeaving(false);
            return;
        }
        setModalLeaving(false);
        const root = document.querySelector('[data-nova-theme]') || document.body;
        // Бэкдроп возвращаем только когда закрывается ПОСЛЕДНИЙ модал:
        // при стопке модалов (открыли несколько подряд) закрытие верхнего
        // не должно вешать наш блюр поверх оставшихся. Считаем «живые»
        // оверлеи (класс _overlay__ без overlayOut/overlayClosing)
        const check = () => {
            let active = 0;
            let leaving = 0;
            root.querySelectorAll('[class*="overlay"]').forEach((el) => {
                const cls = String(el.className);
                // Только модальные оверлеи (локальное имя ровно "overlay");
                // adminOverlay/toastOverlay не в счёт
                if (!/(^|[\s_])overlay(__|\s|$)/.test(cls)) return;
                if (/overlayOut|overlayClosing/.test(cls)) leaving += 1;
                else active += 1;
            });
            setModalLeaving(leaving > 0 && active === 0);
        };
        const mo = new MutationObserver(check);
        mo.observe(root, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
        check();
        return () => mo.disconnect();
    }, [isNovaTheme, anyModalOpen]);
    useEffect(() => {
        if (!isNovaTheme || typeof document === 'undefined') return;
        if (document.querySelector('[data-nova-theme]')) return;
        let raf;
        const check = () => {
            if (document.querySelector('[data-nova-theme]')) {
                bumpNovaRootCheck(n => n + 1);
            } else {
                raf = requestAnimationFrame(check);
            }
        };
        raf = requestAnimationFrame(check);
        return () => cancelAnimationFrame(raf);
    }, [isNovaTheme, adminPanel]);
    // Засеваем список из localStorage-кэша — пикер и группировка по странам
    // рисуются мгновенно при открытии, а сеть обновит список в фоне.
    const [availableConfigs, setAvailableConfigs] = useState(getCachedConfigsListSync);
    const [filteredConfigs, setFilteredConfigs] = useState(getCachedConfigsListSync);
    const [selectedConfig, setSelectedConfig] = useState('');
    const [autoCloseOnClickOutside, setAutoCloseOnClickOutside] = useState(true); // По умолчанию включено

    // Пробрасываем галочку атрибутом на корень документа: минифигма читает
    // его, чтобы её автозакрытие по клику вне подчинялось той же настройке
    useEffect(() => {
        try {
            document.documentElement.toggleAttribute('data-admin-no-autoclose', !autoCloseOnClickOutside);
        } catch (_) {}
    }, [autoCloseOnClickOutside]);

    const [collapsed, setCollapsed] = useState({ user: false, configs: false, cryptoBlock: false, money: false });
    const [userMiniVisible, setUserMiniVisible] = useState({ name: false, bank: false, crypto: false, email: true, telegram: false });
    const [userMoreOpen, setUserMoreOpen] = useState(false);
    const [saveDialog, setSaveDialog] = useState({ open: false, existing: null, newData: null });
    const [showIdentity, setShowIdentity] = useState(false);
    const [previousNameBeforeIdentity, setPreviousNameBeforeIdentity] = useState('');
    
    // Исключения, которые в именах пишутся с маленькой буквы (международные частицы/предлоги)
    const nameLowercaseParticles = new Set([
        // Arabic / Malay / Indonesian
        'bin','binti','ibn','bint','al','el','abu','umm','ummi','bte','bt','abd',
        // Romance languages (Fr/It/Ro)
        'de','du','des','del','dels','le','la','les','di','da','dal','dalla','dalle','dello','delle','della','dei','degli','dell',
        // Iberian (Es/Pt/Ca/Gl)
        'do','dos','da','das','de','del','de','la','de','las','de','los','y','e','i','los','las','lo','das','dos',
        // Germanic / Dutch / Afrikaans
        'van','von','der','den','het','ter','ten','te','op','aan','uit','vom','zum','zur','und','im','am',
        // Scandinavian / Slavic frequent particles
        'af','av','z','ze','od','u','na','po',
        // Celtic (Irish/Scottish Gaelic)
        'nic','ní','ua','uí','o','na','mhic',
        // Hebrew / Persian transliterations
        'ben','bat','bar','ibn','e','ye',
        // Misc small connectors seen cross‑language
        'of','the','and'
    ]);

    const capitalizeWord = (word) => {
        if (!word) return '';
        const first = word.charAt(0).toUpperCase();
        const rest = word.slice(1).toLowerCase();
        return first + rest;
    };

    const normalizePersonName = (rawName) => {
        if (!rawName) return '';
        // Обрабатываем апострофы и дефисы внутри слова, сохраняя разделители
        const normalizeToken = (token) => {
            return token
                .split('-')
                .map(part => nameLowercaseParticles.has(part.toLowerCase()) ? part.toLowerCase() : capitalizeWord(part))
                .join('-');
        };

        return rawName
            .trim()
            .split(/\s+/)
            .map(token => {
                // d'Artagnan, l'Ouverture – оставляем d/ l в нижнем регистре, вторую часть капитализируем
                const apo = token.split("'");
                if (apo.length > 1) {
                    const left = apo[0];
                    const right = apo.slice(1).join("'");
                    const leftNorm = nameLowercaseParticles.has(left.toLowerCase()) ? left.toLowerCase() : capitalizeWord(left);
                    const rightNorm = normalizeToken(right);
                    return `${leftNorm}'${rightNorm}`;
                }
                return normalizeToken(token);
            })
            .join(' ');
    };
    
    // Состояния для управления пользователями
    const [savedUsers, setSavedUsers] = useState([]);
    const [userSuggestions, setUserSuggestions] = useState({ name: [], email: [], cryptoAddress: [] });
    
    // Состояние для предварительно сгенерированных сумм (до сохранения пользователя)
    const [previewGeneratedAmounts, setPreviewGeneratedAmounts] = useState(null);
    const [activeSuggestionField, setActiveSuggestionField] = useState('');
    const [currentTariff, setCurrentTariff] = useState('');
    const [forceResend, setForceResend] = useState(false);
    const [userTelegram, setUserTelegram] = useState('');
    const adminPanelRef = useRef(null);
    
    // Refs для отслеживания первоначальных значений полей при первом фокусе
    const initialFieldValues = useRef({
        name: null,
        email: null,
        cryptoAddress: null,
        telegram: null
    });
    
    // Отслеживание последнего активного поля (которое было в фокусе)
    // Если при focus это то же поле, что было до ухода из окна - не очищаем
    const lastFocusedField = useRef(null);
    
    // Флаг для отслеживания того, что окно браузера потеряло фокус
    // Если окно потеряло фокус, при возврате не очищаем поля
    const windowBlurred = useRef(false);
    
    // Флаг для отслеживания недавнего открытия/закрытия админки
    // Предотвращает очистку имени при открытии/закрытии админки
    const adminPanelJustToggled = useRef(false);
    
    // Отслеживание событий окна для определения ухода/возврата из браузера
    useEffect(() => {
        const handleWindowBlur = () => {
            windowBlurred.current = true;
        };
        
        const handleWindowFocus = () => {
            // При возврате в окно сбрасываем флаг через небольшую задержку
            // чтобы дать время событиям focus на полях обработаться
            setTimeout(() => {
                windowBlurred.current = false;
            }, 100);
        };
        
        window.addEventListener('blur', handleWindowBlur);
        window.addEventListener('focus', handleWindowFocus);
        
        return () => {
            window.removeEventListener('blur', handleWindowBlur);
            window.removeEventListener('focus', handleWindowFocus);
        };
    }, []);

    // Вспомогательные утилиты
    const formatMoscow = (d = new Date()) => new Intl.DateTimeFormat('ru-RU', { timeZone: 'Europe/Moscow', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(d);
    const getCurrentUserRecord = () => {
        // Приоритет: точное совпадение email -> точное совпадение cryptoAddress -> строгая пара (name+crypto)
        if (userEmail) {
            const byEmail = savedUsers.find(u => (u.email || '') === (userEmail || ''));
            if (byEmail) return byEmail;
        }
        if (cryptoAdress) {
            const byAcc = savedUsers.find(u => (u.cryptoAddress || '') === (cryptoAdress || ''));
            if (byAcc) return byAcc;
        }
        if (nameUser && cryptoAdress) {
            const strict = savedUsers.find(u => (u.name || '') === (nameUser || '') && (u.cryptoAddress || '') === (cryptoAdress || ''));
            if (strict) return strict;
        }
        return undefined;
    };

    // Единый генератор суммы для отзовик-режима при выборе тарифа.
    // ОДИН Math.random() на клик: значение кладётся и в поле «Выигрыш»
    // (customMaxMoney), и в сумму модалки успеха (verifyModalAmount) — они
    // всегда совпадают. Модалка успеха больше НЕ перегенерирует сумму,
    // поэтому «отставания на клик» и подстановки первого тарифа не будет.
    // Раньше генерация была продублирована в трёх местах по-разному
    // (+ отдельная в эффекте открытия модалки), что и давало баги.
    const applyOtzovikTariffAmount = (tariff) => {
        if (!siteSettings?.otzovikMode || !setVerifyModalAmount) return;

        // Берём только валидные диапазоны и сортируем по возрастанию суммы —
        // так порядок всегда «меньший → больший» независимо от id/названий.
        const ranges = (siteSettings?.brokerAmountGeneration?.ranges || [])
            .map(r => ({ ...r, min: Number(r.min), max: Number(r.max) }))
            .filter(r => Number.isFinite(r.min) && Number.isFinite(r.max) && r.max >= r.min)
            .sort((a, b) => a.min - b.min);
        if (!ranges.length) return; // нет диапазонов — генерировать нечего

        // Позиция тарифа среди всех тарифов (0-based). Если тариф не найден в
        // списке — разбираем по тексту метки как запасной вариант.
        const label = tariff?.label || '';
        const tariffCount = (Array.isArray(tariffs) && tariffs.length) ? tariffs.length : 5;
        let tariffIndex = Array.isArray(tariffs)
            ? tariffs.findIndex(t => t.label === tariff?.label)
            : -1;
        if (tariffIndex < 0) {
            if (label.includes('1 ТАРИФ')) tariffIndex = 0;
            else if (label.includes('2 ТАРИФ')) tariffIndex = 1;
            else if (label.includes('3 ТАРИФ')) tariffIndex = 2;
            else if (label.includes('4 ТАРИФ')) tariffIndex = 3;
            else if (label.includes('VIP') || label.includes('ВИП')) tariffIndex = tariffCount - 1;
            else tariffIndex = 0;
        }

        // Раскладываем тарифы по доступным диапазонам «по порядку»: тариф i → диапазон i,
        // а если тарифов больше, чем диапазонов — лишние уходят в самый верхний.
        // Работает с любым числом диапазонов (1, 2, 3, …) и любыми id.
        const rangeIdx = Math.min(Math.max(tariffIndex, 0), ranges.length - 1);
        const selectedRange = ranges[rangeIdx] || ranges[ranges.length - 1];
        if (!selectedRange) return;
        const randomAmount = parseFloat((selectedRange.min + (Math.random() * (selectedRange.max - selectedRange.min))).toFixed(2));
        setCustomMaxMoney(randomAmount.toString());
        const depositAmount = siteSettings?.tariffDepositAmounts?.[tariff.label] || 0;
        if (depositAmount > 0) setCustomDepositMoney(depositAmount.toString());
        setVerifyModalAmount(randomAmount);
        if (generateTxId && setLocalSuccessTxId) {
            setLocalSuccessTxId(generateTxId());
        }
    };

    const getUserCheckpoint = (record = {}) => {
        const checkpoint = Number(record.checkpoint);
        return Number.isFinite(checkpoint) && checkpoint > 0 ? checkpoint : 1;
    };

    const getEffectiveSentLog = (record = {}) => {
        const checkpoint = getUserCheckpoint(record);
        const sentLog = record.sentLog || {};

        if (checkpoint <= 1) {
            return {};
        }

        if (checkpoint === 2) {
            return sentLog.registration ? { registration: sentLog.registration } : {};
        }

        return sentLog;
    };

    const getAuditContext = () => {
        const record = getCurrentUserRecord() || {};

        return {
            userId: record.id || null,
            name: nameUser || '',
            email: userEmail || '',
            bankAccount: cryptoAdress || '',
            telegram: userTelegram || '',
            tariff: currentTariff || '',
            bank: network?.name || imgCoin?.name || network || '',
            checkpoint: getUserCheckpoint(record),
            configFile: selectedConfig || currentConfigFile || record.configFile || ''
        };
    };

    const auditAdmin = (action, label, details = {}) => {
        logAudit('admin_panel', action, label, {
            ...getAuditContext(),
            ...details
        });
    };

    const getFieldLabelFromTarget = (target) => {
        let node = target;
        for (let i = 0; i < 5 && node; i += 1) {
            const label = node.querySelector?.('label');
            if (label?.textContent?.trim()) {
                return label.textContent.trim();
            }
            node = node.parentElement;
        }

        return target.getAttribute?.('placeholder') || target.getAttribute?.('aria-label') || target.name || target.type || 'field';
    };

    const getAuditFieldName = (label = '', target) => {
        const normalized = label.toLowerCase();
        const placeholder = (target.getAttribute?.('placeholder') || '').toLowerCase();

        if (normalized.includes('имя') || placeholder.includes('депозит депозитович')) return 'name';
        if (normalized.includes('email') || normalized.includes('e-mail') || placeholder.includes('user@example')) return 'email';
        if (normalized.includes('iban') || normalized.includes('cbu') || normalized.includes('cvu') || normalized.includes('счет') || placeholder.includes('номер счета')) return 'bankAccount';
        if (normalized.includes('телеграм') || placeholder.includes('@username')) return 'telegram';
        if (normalized.includes('выигрыш')) return 'customMaxMoney';
        if (normalized.includes('депозит')) return 'customDepositMoney';
        if (normalized.includes('дата') || normalized.includes('время')) return 'paymentDateTime';
        if (normalized.includes('конфигурац')) return 'selectedConfig';
        if (normalized.includes('криптовалюта')) return 'selectedCrypto';

        return null;
    };

    const handleAdminBlurCapture = (event) => {
        const target = event.target;
        if (!target || !['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) return;
        if (target.type === 'checkbox') return;

        const label = getFieldLabelFromTarget(target);
        const field = getAuditFieldName(label, target);
        if (!field) return;

        auditAdmin('field_blur', `Поле заполнено: ${label}`, {
            field,
            fieldLabel: label,
            value: target.value || ''
        });
    };

    const getReadableClickText = (element) => (
        element?.getAttribute?.('title') ||
        element?.textContent?.replace(/\s+/g, ' ').trim() ||
        element?.getAttribute?.('aria-label') ||
        element?.className ||
        'unknown'
    );

    const handleAdminClickCapture = (event) => {
        const target = event.target;
        const tariffCard = target.closest?.(`.${s.tariffActionCard}`);
        if (tariffCard) {
            auditAdmin('tariff_click', 'Выбран тариф', {
                tariffText: getReadableClickText(tariffCard)
            });
            return;
        }

        const dropdownItem = target.closest?.(`.${s.dropdownItem}`);
        if (dropdownItem) {
            auditAdmin('dropdown_item_click', 'Выбран пункт выпадающего списка', {
                itemText: getReadableClickText(dropdownItem)
            });
            return;
        }

        const button = target.closest?.('button');
        if (!button || !adminPanelRef.current?.contains(button)) return;

        auditAdmin('button_click', 'Нажата кнопка в админке', {
            buttonText: getReadableClickText(button),
            disabled: !!button.disabled
        });
    };

    useEffect(() => {
        if (adminPanel) {
            auditAdmin('open', 'Открыта админка');
        } else {
            auditAdmin('close', 'Закрыта админка');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminPanel]);
    
    // Helper функция для получения значения суммы из generatedAmounts или siteSettings
    const getAmountValue = (fieldKey, tariffLabel) => {
        // Проверяем, нужно ли использовать generatedAmounts
        const useGenerated = siteSettings?.randomizeRanges && !siteSettings?.otzovikMode;
        if (useGenerated) {
            const currentUser = getCurrentUserRecord();
            const generatedAmounts = currentUser?.generatedAmounts || previewGeneratedAmounts;
            
            if (generatedAmounts && generatedAmounts.tariff === tariffLabel) {
                const value = generatedAmounts[fieldKey];
                if (value !== undefined && value !== null) {
                    return value;
                }
            }
        }
        
        // Fallback: используем фиксированные значения из siteSettings
        // Преобразуем ключ из generatedAmounts в ключ настроек
        // Например: "tariffCommission" -> "tariffCommissions", "tariffBaseAmount" -> "tariffBaseAmounts"
        let settingsKey = fieldKey;
        if (fieldKey === 'tariffCommission') {
            settingsKey = 'tariffCommissions';
        } else if (fieldKey === 'tariffBaseAmount') {
            settingsKey = 'tariffBaseAmounts';
        } else if (fieldKey === 'tariffDepositAmount') {
            settingsKey = 'tariffDepositAmounts';
        } else if (fieldKey === 'tariffVerificationAmount') {
            settingsKey = 'tariffVerificationAmounts';
        } else if (fieldKey === 'tariffAdditionalAmount') {
            settingsKey = 'tariffAdditionalAmounts';
        } else if (fieldKey === 'tariffTaxPercent') {
            settingsKey = 'tariffTaxPercents';
        } else if (fieldKey === 'tariffConversionCommission') {
            settingsKey = 'tariffConversionCommissions';
        } else if (fieldKey === 'tariffBankFee') {
            settingsKey = 'tariffBankFees';
        } else if (fieldKey === 'tariffBrokerFee') {
            settingsKey = 'tariffBrokerFees';
        } else if (fieldKey === 'tariffWinningPercentage') {
            settingsKey = 'tariffWinningPercentages';
        } else {
            // Общий случай: добавляем 's' в конец
            settingsKey = fieldKey + 's';
        }
        return siteSettings?.[settingsKey]?.[tariffLabel] ?? 0;
    };

    const usersFindDuplicate = (userData) => {
        const byId = userData.id ? savedUsers.find(u => String(u.id) === String(userData.id)) : null;
        if (byId) return byId;
        // Дубликат считаем ТОЛЬКО по email или CBU/CVU (cryptoAddress)
        if (userData.email) {
            const byEmail = savedUsers.find(u => (u.email || '').toLowerCase() === userData.email.toLowerCase());
            if (byEmail) return byEmail;
        }
        if (userData.cryptoAddress) {
            const byAcc = savedUsers.find(u => (u.cryptoAddress || '') === userData.cryptoAddress);
            if (byAcc) return byAcc;
        }
        return null;
    };

    const usersAreEqual = (a = {}, b = {}) => {
        return (
            (a.name || '') === (b.name || '') &&
            (a.email || '') === (b.email || '') &&
            (a.cryptoAddress || '') === (b.cryptoAddress || '') &&
            (a.tariff || '') === (b.tariff || '') &&
            (a.selectedBank || '') === (b.selectedBank || '') &&
            (a.telegram || '') === (b.telegram || '')
        );
    };

    // Функция для загрузки сохраненных пользователей (локально с загрузкой из файла)
    const loadSavedUsers = async () => {
        try {
            const { getLocalUsers } = await import('../../utils/userUtils');
            const users = await getLocalUsers();
            setSavedUsers(users);
            console.log('Загружено пользователей:', users.length);
        } catch (error) {
            console.error('Ошибка загрузки пользователей:', error);
            setSavedUsers([]);
        }
    };

    // Live-обновления пользователей через SSE (отключено, используем localStorage)
    useEffect(() => {
        if (!adminPanel || saveDialog.open) return;
        // Просто загружаем пользователей из localStorage
            loadSavedUsers();
    }, [adminPanel, saveDialog.open]);

    // Обновление подсказок по введенному значению
    const updateUserSuggestions = (fieldKey, value) => {
        const normalized = (value || '').trim().toLowerCase();
        if (!normalized) {
            setUserSuggestions(prev => ({ ...prev, [fieldKey]: [] }));
            return;
        }
        const list = savedUsers
            .filter(u => String(u[fieldKey] || '').toLowerCase().includes(normalized))
            .slice(0, 5);
        setUserSuggestions(prev => ({ ...prev, [fieldKey]: list }));
    };

    const applyUserFromSuggestion = (user) => {
        setNameUser(user.name || '');
        setUserEmail(user.email || '');
        setcryptoAdress(user.cryptoAddress || '');
        setUserTelegram(user.telegram || '');
        // Сбрасываем ref'ы для отслеживания первоначальных значений при загрузке нового пользователя
        initialFieldValues.current = {
            name: null,
            email: null,
            cryptoAddress: null,
            telegram: null
        };
        // Сбрасываем последнее активное поле при загрузке нового пользователя
        lastFocusedField.current = null;
        
        // Загружаем generatedAmounts пользователя (если есть)
        if (user.generatedAmounts) {
            setPreviewGeneratedAmounts(user.generatedAmounts);
            // Обновляем глобальное состояние для использования в MiniFigma, Chat и т.д.
            if (setCurrentUserGeneratedAmounts) {
                setCurrentUserGeneratedAmounts(user.generatedAmounts);
            }
        } else {
            setPreviewGeneratedAmounts(null);
            if (setCurrentUserGeneratedAmounts) {
                setCurrentUserGeneratedAmounts(null);
            }
        }
        
        // Применяем сохраненный тариф (если есть)
        if (user.tariff) {
            setCurrentTariff(user.tariff);
            // Найдем объект тарифа по метке и применим через исходный обработчик
            const tariffObj = tariffs?.find(t => t.label === user.tariff);
            if (tariffObj && typeof handleTariffClick === 'function') {
                try { 
                    // Передаем generatedAmounts пользователя в handleTariffClick
                    handleTariffClick(tariffObj, user.generatedAmounts || null); 
                } catch (_) {}
            }
        }
        // Применяем сохраненный банк (если есть)
        if (user.selectedBank && Array.isArray(networks)) {
            const net = networks.find(n => n.name === user.selectedBank);
            if (net) {
                try { handleNetworkSelect(net); } catch (_) {
                    // если handleNetworkSelect недоступен, применим напрямую
                    setNetwork(net.name);
                    setImgCoin(net);
                }
            }
        }
        // Сбрасываем локальный режим форс‑ресенда при выборе из подсказки
        setForceResend(false);
        setActiveSuggestionField('');
        setUserSuggestions({ name: [], email: [], cryptoAddress: [] });
    };

    const doSaveWithMode = async (mode, data, existing) => {
        // Логика чекпоинтов и статусов:
        // 1) new     → всегда новый пользователь: checkpoint=1, sentLog={}
        // 2) update  → меняем только данные, прогресс сохраняем как был
        //              (чекпоинт и отметки об отправленных письмах не трогаем)
        // 3) replace → меняем данные и полностью сбрасываем прогресс:
        //              checkpoint=1, sentLog={}, письма можно слать заново (forceResend)
        let payload = { ...data, mode };
        let enableForceResend = false;
        if (mode === 'new') {
            payload.checkpoint = 1;
            payload.sentLog = {};
        } else if (mode === 'update') {
            // оставляем существующие checkpoint/sentLog нетронутыми
            payload.checkpoint = existing?.checkpoint ?? data.checkpoint;
            payload.sentLog = existing?.sentLog ?? data.sentLog;
        } else if (mode === 'replace') {
            payload.checkpoint = 1;
            payload.sentLog = {};
            enableForceResend = true;
        }
        if (existing && existing.id && (mode === 'update' || mode === 'replace')) {
            payload.id = existing.id;
            // Сохраняем оригинальный timestamp (дату регистрации)
            payload.timestamp = existing.timestamp || payload.timestamp;
            // Сохраняем generatedAmounts: если в payload есть - используем его, иначе оставляем существующие
            if (payload.generatedAmounts === undefined || payload.generatedAmounts === null) {
                payload.generatedAmounts = existing.generatedAmounts || null;
            }
        }
        
        console.log('[AdminPanel] doSaveWithMode - payload.generatedAmounts:', payload.generatedAmounts);
        auditAdmin('save_user_attempt', 'Попытка сохранения юзера', {
            mode,
            payload
        });
        
        try {
            const { saveLocalUser } = await import('../../utils/userUtils');
            // При создании нового пользователя передаем configFile, при обновлении - не передаем (чтобы не перезаписать изначальный)
            const savePayload = mode === 'new' 
                ? { ...payload, configFile: currentConfigFile }
                : { ...payload }; // При update/replace не передаем configFile, чтобы сохранить изначальный
            const result = await saveLocalUser(savePayload);
            
            if (!result.success) {
                throw new Error(result?.error || 'Save failed');
            }
            auditAdmin('save_user_success', 'Юзер сохранен', {
                mode,
                id: result.id || payload.id || null,
                payload
            });
            
        // Обновляем локально поле имени на нормализованное значение сразу после сохранения
        try { setNameUser(data?.name || ''); } catch(_) {}
            try { window.dispatchEvent(new CustomEvent('app:toast', { detail: { type: 'success', message: 'Пользователь сохранен на сервер' } })); } catch(_) {}
        await loadSavedUsers();
        setSaveDialog({ open: false, existing: null, newData: null });
        // Активируем локально повторную отправку обеих писем только при update/replace с измененными ключами
        setForceResend(enableForceResend);
        } catch (error) {
            console.error('Ошибка сохранения пользователя:', error);
            auditAdmin('save_user_error', 'Ошибка сохранения юзера', {
                mode,
                error: error.message
            });
            throw error;
        }
    };

    const handleSaveUser = async (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        
        if (!nameUser.trim() || !cryptoAdress.trim()) {
            auditAdmin('save_user_validation_error', 'Ошибка валидации сохранения юзера', {
                reason: 'name_or_bank_account_missing'
            });
            notifyWarning('Заполните обязательные поля: Имя и CBU/CVU');
            return;
        }

        const existing = getCurrentUserRecord() || {};
        
        // Определяем какие generatedAmounts использовать:
        // 1. Если есть previewGeneratedAmounts (только что сгенерированные) - используем их
        // 2. Иначе если у существующего пользователя есть generatedAmounts - используем их
        // 3. Иначе null
        let finalGeneratedAmounts = null;
        if (previewGeneratedAmounts) {
            finalGeneratedAmounts = previewGeneratedAmounts;
        } else if (existing.generatedAmounts) {
            finalGeneratedAmounts = existing.generatedAmounts;
        }
        
        console.log('[AdminPanel] handleSaveUser - previewGeneratedAmounts:', previewGeneratedAmounts);
        console.log('[AdminPanel] handleSaveUser - existing.generatedAmounts:', existing.generatedAmounts);
        console.log('[AdminPanel] handleSaveUser - finalGeneratedAmounts:', finalGeneratedAmounts);
        
        const userData = {
            name: normalizePersonName(nameUser.trim()),
            email: userEmail.trim(),
            cryptoAddress: cryptoAdress.trim(),
            tariff: currentTariff,
            selectedBank: network?.name || imgCoin?.name || '',
            telegram: (userTelegram || '').trim(),
            timestamp: existing?.timestamp || new Date().toISOString(), // Сохраняем оригинальный timestamp если есть
            checkpoint: existing.checkpoint || 1,
            sentLog: existing.sentLog || {},
            // Сохраняем сгенерированные суммы
            generatedAmounts: finalGeneratedAmounts
        };

        try {
            const duplicate = usersFindDuplicate(userData);
            if (duplicate) {
                if (usersAreEqual(duplicate, userData)) {
                    auditAdmin('save_user_no_changes', 'Попытка сохранить юзера без изменений', {
                        userData,
                        duplicate
                    });
                    try { window.dispatchEvent(new CustomEvent('app:toast', { detail: { type: 'error', message: 'Нет изменений для сохранения' } })); } catch(_) {}
                    return;
                }
                auditAdmin('save_user_duplicate_dialog', 'Открыт диалог дубликата юзера', {
                    userData,
                    duplicate
                });
                setSaveDialog({ open: true, existing: duplicate, newData: userData });
                return;
            }
            await doSaveWithMode('new', userData);
        } catch (error) {
            console.error('❌ Ошибка при сохранении пользователя:', error);
            auditAdmin('save_user_error', 'Ошибка при сохранении', {
                error: error.message
            });
            notifyError('Ошибка при сохранении: ' + error.message);
        }
    };

    // Выбор конфига (общий для нативного select и кастомного дропдауна)
    const applyConfigByFilename = async (filename) => {
        setSelectedConfig(filename);
        if (!filename) return;
        try {
            const { loadLocalConfig } = await import('../../utils/configUtils');
            const configData = await loadLocalConfig(filename);
            if (onApplyConfig) {
                onApplyConfig(configData, filename);
            }
        } catch (error) {
            console.error('Ошибка применения конфига:', error);
            notifyError('Ошибка при применении конфига: ' + error.message);
        }
    };

    // Дропдаун конфигов с группировкой по странам (поиск + хайды).
    // Один компонент на обе темы, отличается только оформлением
    const renderConfigPicker = () => (
        <div className={s.fieldGroup}>
            <label className={s.fieldLabel}>Выберите конфигурацию</label>
            <ConfigPicker
                configs={filteredConfigs}
                value={selectedConfig}
                onSelect={applyConfigByFilename}
                open={configDropdownOpen}
                onToggle={() => {
                    // Открывая этот дропдаун, закрываем остальные — иначе наслаиваются
                    setCryptoDropdownOpen(false);
                    setNetworkDropdownOpen(false);
                    setUserMoreOpen(false);
                    setConfigDropdownOpen(!configDropdownOpen);
                }}
                onClose={() => setConfigDropdownOpen(false)}
                variant={isNovaTheme ? 'nova' : 'classic'}
            />
        </div>
    );

    // Функция для поиска пользователя по имени, email или адресу
    const findUserByField = (value, field) => {
        return savedUsers.find(user => 
            user[field]?.toLowerCase().includes(value.toLowerCase())
        );
    };

    // Закрытие дропдаунов при клике вне области (на уровне окна)
    useEffect(() => {
        if (!adminPanel || saveDialog.open) return;
        const handleClickOutside = (event) => {
            const dropdownEl = event.target.closest('[class*="dropdownMenu"], [class*="dropdownBtn"], [class*="dropdown"]');
            if (!dropdownEl) {
                setNetworkDropdownOpen(false);
                setCryptoDropdownOpen(false);
                setConfigDropdownOpen(false);
                setActiveSuggestionField('');
            }
            // Меню трёх точек закрываем при клике вне него самого и вне кнопки-открывашки
            const moreEl = event.target.closest('[class*="moreMenu"], [class*="iconControlBtn"]');
            if (!moreEl) {
                setUserMoreOpen(false);
            }
        };
        window.addEventListener('mousedown', handleClickOutside, true);
        return () => window.removeEventListener('mousedown', handleClickOutside, true);
    }, [adminPanel, saveDialog.open]);



    // Функция для получения действий быстрых действий
    const getQuickActionsConfig = () => {
        const isOtzovikMode = siteSettings?.otzovikMode || false;
        
        const actions = {
            commission: {
                icon: commissionModalIcon,
                action: () => {
                    auditAdmin('modal_open', 'Открыт модал комиссии', { modal: 'commission' });
                    console.log('🚀 Opening verification modal from AdminPanel (commission)');
                    setshowVerifyModal(true);
                    console.log('🚀 showVerifyModal set to true from AdminPanel');
                },
                defaultName: 'Комиссия'
            },
            verification: {
                icon: verificationModalIcon,
                action: () => {
                    auditAdmin('modal_open', 'Открыт модал верификации', { modal: 'verification' });
                    setSendingErrorModal(true);
                },
                defaultName: 'Верификация'
            },
            success: {
                icon: successModalIcon,
                action: async () => {
                    auditAdmin('modal_open', 'Открыт модал успеха', { modal: 'success' });
                    setShowModaWithdrawal(true);
                },
                defaultName: 'Успех'
            },
            tax: {
                icon: taxModalIcon,
                action: () => {
                    auditAdmin('modal_open', 'Открыт модал налога', { modal: 'tax' });
                    setshowNalogModal(true);
                },
                defaultName: 'Налог'
            },
            cryptoConversion: {
                icon: cryptoConversionModalIcon,
                action: () => {
                    auditAdmin('modal_open', 'Открыт модал конвертации крипты', { modal: 'cryptoConversion' });
                    setShowCryptoConversionModal(true);
                },
                defaultName: 'Конверт крипта'
            },
            bankConversion: {
                icon: bankConversionModalIcon,
                action: () => {
                    auditAdmin('modal_open', 'Открыт модал банковской конвертации', { modal: 'bankConversion' });
                    setShowBankConversionModal(true);
                },
                defaultName: 'Конверт банк'
            },
            code: {
                icon: verificationModalIcon, // Используем иконку верификации как временную
                action: () => {
                    auditAdmin('modal_open', 'Открыт модал кода', { modal: 'code' });
                    setShowCodeModal && setShowCodeModal(true);
                },
                defaultName: 'Код'
            },
            premium: {
                icon: verificationModalIcon, // Временно используем иконку верификации, можно заменить на premium иконку
                action: () => {
                    auditAdmin('modal_open', 'Открыт модал премиум доступа', { modal: 'premium' });
                    console.log('🚀 Opening premium modal from AdminPanel');
                    setShowPremiumModal && setShowPremiumModal(true);
                },
                defaultName: 'Премиум доступ'
            }
        };

        // Добавляем кастомные модалы из siteSettings.modalTemplates
        const customModals = siteSettings?.modalTemplates || [];
        console.log('🔍 getQuickActionsConfig - customModals:', {
            customModalsCount: customModals.length,
            customModals: customModals,
            siteSettingsHasModalTemplates: !!siteSettings?.modalTemplates
        });
        customModals.forEach(template => {
            if (template.enabled !== false && template.actionKey) {
                const modalKey = `custom_${template.actionKey}`;
                // Создаем функцию для открытия модала
                // Используем переданную функцию setCustomModalState если она есть
                actions[modalKey] = {
                    icon: template.icon || '📝',
                    action: () => {
                        auditAdmin('modal_open', 'Открыт кастомный модал', {
                            modal: modalKey,
                            template
                        });
                        // Вызываем функцию для открытия кастомного модала
                        if (setCustomModalState) {
                            setCustomModalState(modalKey, true);
                        } else {
                            console.warn('setCustomModalState не передан в AdminPanel');
                        }
                    },
                    defaultName: template.name || `Modal ${template.actionKey}`,
                    isCustom: true,
                    template: template
                };
            }
        });

        // В режиме отзовика оставляем только success
        const filteredActions = isOtzovikMode 
            ? { success: actions.success }
            : actions;

        // Получаем настройки из siteSettings
        const quickActionsSettings = siteSettings?.quickActions || {};
        

        
        // Создаем массив действий с настройками
        return Object.entries(filteredActions)
            .map(([key, config]) => {
                const settings = quickActionsSettings[key] || { enabled: true, priority: 1 };
                return {
                    key,
                    ...config,
                    enabled: settings.enabled !== false,
                    emailEnabled: config.isCustom ? (config.template?.emailEnabled !== false) : (settings.emailEnabled !== false),
                    priority: config.isCustom ? (config.template?.priority || 1) : (settings.priority || 1),
                    name: config.defaultName // ВСЕГДА используем русское название из defaultName
                };
            })
            .sort((a, b) => (a.priority || 999) - (b.priority || 999));
    };

    // Функция для получения иконки криптовалюты
    const getCryptoIcon = (crypto) => {
        switch (crypto) {
            case 'BTC':
                return bitcoinIcon;
            case 'ETH':
                return ethereumIcon;
            case 'BNB':
                return binanceIcon;
            case 'TRX':
                return tronIcon;
            case 'USDC':
                return usdcIcon;
            case 'SOL':
                return solanaIcon;
            default:
                return bitcoinIcon; // Fallback
        }
    };

  // Форматирование даты/времени для писем согласно настройкам SiteSettings
  const formatDateTimeForEmails = () => {
    try {
      const tz = siteSettings?.timeZone || siteSettings?.timezone || 'Europe/Moscow';
      const locale = siteSettings?.locale || 'es-ES';
      const dateTimeSettings = siteSettings?.dateTimeSettings || {};
      const showTime = dateTimeSettings.showDateTime === true;
      const timeFormat = dateTimeSettings.timeFormat || '24h';
      // Разбор формата даты (используем только порядок и разделитель)
      const dateFormat = dateTimeSettings.dateFormat || 'dd/MM/yyyy';
      const fmt = { timeZone: tz };
      fmt.day = '2-digit';
      fmt.month = '2-digit';
      fmt.year = 'numeric';
      if (showTime) {
        fmt.hour = '2-digit';
        fmt.minute = '2-digit';
        fmt.hour12 = timeFormat === '12h';
      }
      return new Intl.DateTimeFormat(locale, fmt).format(new Date());
    } catch (_) {
      return new Date().toLocaleString('es-ES');
    }
  };

  // Формат числа по настройке SiteSettings.numberFormat
  const formatNumberBySettings = (value, minFrac = 2, maxFrac = 2) => {
    // Используем тот же формат, что и весь сайт: 'comma' (10,294.98 — запятая для
    // тысяч, точка для десятых) или 'dot' (10.294,98 — наоборот). Разделители
    // ставим вручную, без зависимости от системной локали, иначе Intl по локали
    // 'es-ES' всегда давал европейский формат и игнорировал настройку.
    const useDot = (siteSettings?.numberFormat || 'comma') === 'dot';
    const num = Number(value);
    const safe = Number.isFinite(num) ? num : 0;

    let fixed = safe.toFixed(Math.max(minFrac, maxFrac));
    if (maxFrac > minFrac) {
      let [intStr, decStr = ''] = fixed.split('.');
      while (decStr.length > minFrac && decStr.endsWith('0')) decStr = decStr.slice(0, -1);
      fixed = decStr ? `${intStr}.${decStr}` : intStr;
    }

    const [intPart, decPart] = fixed.split('.');
    const thousandSep = useDot ? '.' : ',';
    const decimalSep = useDot ? ',' : '.';
    const groupedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
    return (decPart !== undefined && decPart !== '') ? `${groupedInt}${decimalSep}${decPart}` : groupedInt;
  };

  // Депозит по текущему тарифу из настроек (fallback — введённый депозит)
  const getDepositForCurrentTariff = () => {
    // Проверяем, нужно ли использовать generatedAmounts
    const useGenerated = siteSettings?.randomizeRanges && !siteSettings?.otzovikMode;
    if (useGenerated) {
        const currentUser = getCurrentUserRecord();
        const generatedAmounts = currentUser?.generatedAmounts || previewGeneratedAmounts;
        
        if (generatedAmounts && generatedAmounts.tariff === currentTariff) {
            const depositValue = generatedAmounts.tariffDepositAmount;
            if (depositValue !== undefined && depositValue !== null) {
                return depositValue;
            }
        }
    }
    
    // Fallback: используем фиксированные значения из siteSettings или customDepositMoney
    const byTariff = siteSettings?.tariffDepositAmounts?.[currentTariff];
    if (typeof byTariff === 'number') return byTariff;
    const num = Number(customDepositMoney);
    return Number.isFinite(num) ? num : 0;
  };

  // Процент выигрыша — всегда вычисляем из чисел
  const getWinningPercentForTariff = (winAmount, depositAmount) => {
    const d = Number(depositAmount) || 0;
    const w = Number(winAmount) || 0;
    return d > 0 ? ((w - d) / d) * 100 : 0;
  };

  // Проверка изменения ключевых полей
  const isKeyFieldsChanged = (prevUser = {}, nextData = {}) => {
    const prevEmail = (prevUser.email || '').trim();
    const prevAcc = (prevUser.cryptoAddress || '').trim();
    const prevBank = (prevUser.selectedBank || '').trim();
    const nextEmail = (nextData.email || '').trim();
    const nextAcc = (nextData.cryptoAddress || '').trim();
    const nextBank = (nextData.selectedBank || '').trim();
    return prevEmail !== nextEmail || prevAcc !== nextAcc || prevBank !== nextBank;
    };

    // Функция для получения списка конфигов локально
    const getConfigsList = async () => {
        try {
            console.log('Загружаем список конфигов локально...');
            const { getLocalConfigsList } = await import('../../utils/configUtils');
            const configs = await getLocalConfigsList();
            console.log('Найденные конфиги:', configs);
            return configs || [];
        } catch (error) {
            console.error('Не удалось загрузить конфиги:', error);
            return [];
        }
    };

    // В режиме отзовика автоматически включаем галочку "Показать личность"
    useEffect(() => {
        if (siteSettings?.otzovikMode && siteSettings?.defaultUserName) {
            setShowIdentity(true);
            if (nameUser !== siteSettings.defaultUserName) {
                setPreviousNameBeforeIdentity(nameUser || '');
                setNameUser(siteSettings.defaultUserName);
                if (setConfirmedNameUser) {
                    setConfirmedNameUser(siteSettings.defaultUserName);
                }
            }
        }
    }, [siteSettings?.otzovikMode, siteSettings?.defaultUserName]);

    // Загружаем список доступных конфигов при каждом открытии Admin Panel
    useEffect(() => {
        if (adminPanel) {
            console.log('Admin Panel открыт, загружаем актуальный список конфигов...');
            getConfigsList().then(async (configs) => {
                setAvailableConfigs(configs);
                console.log('Список конфигов обновлен:', configs.length, 'конфигов');
                
                // Фильтруем конфиги по разрешениям пользователя
                const allowedConfigs = await getAllowedConfigs();
                if (allowedConfigs === null) {
                    // Админ видит все конфиги
                    setFilteredConfigs(configs);
                } else {
                    // Фильтруем по разрешенным конфигам
                    const filtered = configs.filter(config => {
                        const filename = config.filename || config;
                        return allowedConfigs.includes(filename);
                    });
                    setFilteredConfigs(filtered);
                    
                    // У не-админа не должно быть состояния «не выбран»: если ещё
                    // ничего не выбрано — применяем ПЕРВЫЙ доступный конфиг
                    // (для единственного это тот же случай). Уже выбранный не трогаем.
                    // Имя пользователя не сбросится — handleApplyConfig это учитывает.
                    if (filtered.length >= 1 && onApplyConfig && !selectedConfig && !currentConfigFile) {
                        try {
                            const configInfo = filtered[0];
                            const filename = configInfo.filename || configInfo;
                            const { loadLocalConfig } = await import('../../utils/configUtils');
                            const configData = await loadLocalConfig(filename);
                            onApplyConfig(configData, filename);
                            setSelectedConfig(filename);
                            console.log('Автоматически применён первый доступный конфиг:', filename);
                        } catch (error) {
                            console.error('Ошибка автоматического применения конфига:', error);
                        }
                    }
                }
            }).catch(error => {
                console.error('Ошибка при загрузке конфигов:', error);
                setAvailableConfigs([]);
                setFilteredConfigs([]);
            });
            
            // Также загружаем сохраненных пользователей
            loadSavedUsers();
        }
    }, [adminPanel]);
    
    // Сортируем сети по приоритету из настроек банков
    const sortedNetworks = [...networks].sort((a, b) => {
        const pa = Number(siteSettings?.banks?.[a.name]?.priority ?? 9999);
        const pb = Number(siteSettings?.banks?.[b.name]?.priority ?? 9999);
        return pa - pb;
    });

    // Используем отсортированный список
    const enabledNetworks = sortedNetworks.filter(net => {
        const bank = siteSettings?.banks?.[net.name];
        return bank?.enabled !== false;
    });

    const configuredCryptoSymbols = Object.keys(siteSettings?.walletsByCurrency || siteSettings?.cryptoWallets || {});
    const availableCryptoOptions = configuredCryptoSymbols.length > 0
        ? cryptoOptions.filter(crypto => configuredCryptoSymbols.includes(crypto.symbol))
        : cryptoOptions.filter(crypto => crypto.symbol === (siteSettings?.defaultCrypto || selectedCrypto || 'ETH'));
    const selectedCryptoOption = availableCryptoOptions.find(c => c.symbol === selectedCrypto) || availableCryptoOptions[0] || cryptoOptions.find(c => c.symbol === selectedCrypto) || cryptoOptions[0];

    useEffect(() => {
        if (selectedCryptoOption?.symbol && selectedCrypto !== selectedCryptoOption.symbol) {
            setSelectedCrypto(selectedCryptoOption.symbol);
        }
    }, [selectedCryptoOption?.symbol, selectedCrypto, setSelectedCrypto]);

    // По умолчанию выбираем первый по приоритету банк
    useEffect(() => {
        const first = enabledNetworks[0]?.name;
        if (first && network !== first) {
            setNetwork(first);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabledNetworks.length]);
    
    // Проверяем, что текущий выбранный банк все еще включен
    const isCurrentNetworkEnabled = enabledNetworks.some(net => net.name === network);
    
    // Если текущий банк отключен, выбираем первый доступный
    useEffect(() => {
        if (!isCurrentNetworkEnabled && enabledNetworks.length > 0) {
            handleNetworkSelect(enabledNetworks[0]);
        }
    }, [isCurrentNetworkEnabled, enabledNetworks]);
    
    const handleNetworkSelect = (net) => {
        auditAdmin('bank_select', 'Выбран банк', {
            bank: net?.name || '',
            icon: net?.img || ''
        });
        setNetwork(net.name);
        setImgCoin(net);
        setNetworkDropdownOpen(false);
    };
    
    const handleCryptoSelect = (crypto) => {
        auditAdmin('crypto_select', 'Выбрана криптовалюта', {
            symbol: crypto?.symbol || '',
            name: crypto?.name || ''
        });
        setSelectedCrypto(crypto.symbol);
        setCryptoDropdownOpen(false);
    };

    // Универсальная отправка письма по actionKey (вторая линия)
    const handleSendActionEmail = async (actionKey) => {
        try {
            const record = getCurrentUserRecord() || {};
            auditAdmin('send_action_email_attempt', 'Попытка отправки письма второй линии', {
                actionKey,
                record
            });
            const effectiveSentLog = getEffectiveSentLog(record);
            if (effectiveSentLog?.[actionKey]?.sent && !forceResend) {
                auditAdmin('send_action_email_blocked', 'Отправка письма второй линии заблокирована старым статусом', {
                    actionKey,
                    effectiveSentLog
                });
                try { window.dispatchEvent(new CustomEvent('app:toast', { detail: { type: 'info', message: 'Письмо уже отправлено ранее' } })); } catch(_) {}
                return;
            }
            const tplRes = await fetch('/api/config/templates/');
            const tplData = await tplRes.json();
            const templates = Array.isArray(tplData.templates) ? tplData.templates : [];
            // Используем selectedConfig или currentConfigFile как fallback
            const activeCfg = selectedConfig || currentConfigFile || '';
            // Проверяем allowedConfigs: если пустой массив или undefined - разрешено для всех, иначе только для указанных
            const tpl = templates.find(t => {
                if (t.actionKey !== actionKey) return false;
                // Если allowedConfigs не задан или пустой - шаблон доступен для всех конфигов
                if (!t.allowedConfigs || t.allowedConfigs.length === 0) return true;
                // Если allowedConfigs задан - проверяем, что текущий конфиг в списке
                return t.allowedConfigs.includes(activeCfg);
            });
            if (!tpl) { 
                notifyError('Не найден шаблон для действия: ' + actionKey + (activeCfg ? ' (конфиг: ' + activeCfg + ')' : ' (конфиг не выбран)')); 
                return; 
            }

            const currencySymbol = siteSettings?.currencyFormat || '$';
            const bankAccount = (cryptoAdress || '').trim();
            const bankFromSaved = (savedUsers || []).find(u => (u.email && u.email === userEmail) || (u.name && u.name === nameUser))?.selectedBank || '';
            const bank = (network?.name || imgCoin?.name || bankFromSaved || '').trim();
            const bankInfo = siteSettings?.banks?.[bank];
            const baseOriginRaw = siteSettings?.publicBaseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
            const baseOrigin = (baseOriginRaw || '').startsWith('http://') ? baseOriginRaw.replace('http://', 'https://') : (baseOriginRaw || '');
            const bankIconUrl = bankInfo?.iconUrl || (bankInfo?.iconFileName ? `/bankicons/${bankInfo.iconFileName}` : '');
            const defaultCrypto = selectedCrypto || siteSettings?.defaultCrypto || '';
            // Финансы по тарифу
            const depositAmountVal = getDepositForCurrentTariff();
            const userWinningVal = Number(maxTotalMoney) || 0;
            const userWinningPercentVal = getWinningPercentForTariff(userWinningVal, depositAmountVal);
            // Кошельки выбираются по криптовалюте из dropdown админки.
            const {
                mainWalletAddress,
                commissionWalletAddress,
                commissionWalletQr,
                verificationWalletAddress,
                verificationWalletQr,
                taxWalletAddress,
                taxWalletQr,
                cryptoConversionWalletAddress,
                cryptoConversionWalletQr,
                bankConversionWalletAddress,
                bankConversionWalletQr
            } = getEmailWalletVariables(siteSettings, defaultCrypto, cryptoOptions);

            const subject = (tpl.subject || '');
            const text = (tpl.content || tpl.html || '');
            const normalizedUserName = normalizePersonName(nameUser || '');
            
            // Получаем verificationCode из предыдущего регистрационного письма, если есть
            const verificationCode = record?.sentLog?.registration?.verificationCode || '';
            
            const process = (str) => {
                let result = (str || '')
                .replace(/\{userName\}/g, normalizedUserName || 'Пользователь')
                .replace(/\{userEmail\}/g, userEmail || '')
                .replace(/\{bankAccount\}/g, bankAccount)
                .replace(/\{cryptoAddress\}/g, bankAccount)
                .replace(/\{bank\}/g, bank)
                .replace(/\{selectedBank\}/g, bank)
                .replace(/\{bankIconUrl\}/g, bankIconUrl)
                .replace(/\{currentTime\}/g, formatDateTimeForEmails())
                .replace(/\{currencySymbol\}/g, currencySymbol)
                .replace(/\{verificationCode\}/g, verificationCode)
                .replace(/\{defaultCrypto\}/g, siteSettings?.defaultCrypto || '')
                .replace(/\{depositAmount\}/g, formatNumberBySettings(depositAmountVal))
                .replace(/\{userWinning\}/g, formatNumberBySettings(userWinningVal))
                .replace(/\{userWinningPercent\}/g, `${formatNumberBySettings(userWinningPercentVal, 1, 1)}%`)
                    .replace(/\{userWinningPlusAdditional\}/g, formatNumberBySettings((Number(userWinningVal)||0) + (Number(getAmountValue('tariffAdditionalAmount', currentTariff))||0)))
                    .replace(/\{commissionAmount\}/g, formatNumberBySettings(getAmountValue('tariffCommission', currentTariff)))
                .replace(/\{commissionPercent\}/g, (() => {
                    const winNum = Number(userWinningVal) || 0;
                        const commNum = Number(getAmountValue('tariffCommission', currentTariff)) || 0;
                    const pct = winNum > 0 ? (commNum / winNum) * 100 : 0;
                    return `${formatNumberBySettings(pct, 1, 1)}%`;
                })())
                    .replace(/\{verificationAmount\}/g, formatNumberBySettings(getAmountValue('tariffVerificationAmount', currentTariff)))
                    .replace(/\{additionalAmount\}/g, formatNumberBySettings(getAmountValue('tariffAdditionalAmount', currentTariff)))
                    .replace(/\{taxPercent\}/g, `${formatNumberBySettings(getAmountValue('tariffTaxPercent', currentTariff), 0, 2)}%`)
                    .replace(/\{conversionFee\}/g, formatNumberBySettings(getAmountValue('tariffConversionCommission', currentTariff)))
                    .replace(/\{bankFee\}/g, formatNumberBySettings(getAmountValue('tariffBankFee', currentTariff)))
                    .replace(/\{brokerFee\}/g, formatNumberBySettings(getAmountValue('tariffBrokerFee', currentTariff)));
                
                // Добавляем переменные для кастомных модалов
                if (siteSettings?.modalTemplates) {
                    siteSettings.modalTemplates.forEach(template => {
                        if (template.financeFieldName && template.actionKey) {
                            const actionKeyCapitalized = template.actionKey.charAt(0).toUpperCase() + template.actionKey.slice(1);
                            const settingsKey = `tariff${actionKeyCapitalized}Amounts`;
                            const rangesKey = `${settingsKey}Ranges`;
                            const fieldKey = `tariff${actionKeyCapitalized}Amount`;
                            
                            // Получаем сумму для кастомного модала
                            let customAmount = 0;
                            const useGenerated = siteSettings?.randomizeRanges && !siteSettings?.otzovikMode;
                            if (useGenerated && currentUser?.generatedAmounts?.[fieldKey] !== undefined && currentUser.generatedAmounts[fieldKey] !== null) {
                                customAmount = currentUser.generatedAmounts[fieldKey];
                            } else {
                                const fixedAmount = siteSettings?.[settingsKey]?.[currentTariff];
                                if (fixedAmount !== undefined && fixedAmount !== null && fixedAmount !== 0) {
                                    customAmount = fixedAmount;
                                } else {
                                    const ranges = siteSettings?.[rangesKey]?.[currentTariff];
                                    if (ranges && ranges.min !== undefined && ranges.max !== undefined) {
                                        if (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode) {
                                            customAmount = ranges.min + Math.random() * (ranges.max - ranges.min);
                                        } else {
                                            customAmount = (ranges.min + ranges.max) / 2;
                                        }
                                    }
                                }
                            }
                            
                            // Добавляем переменные: {actionKeyAmount}, {actionKeyAmountLower}, {actionKeyAmountUpper}
                            const varName = `{${template.actionKey}Amount}`;
                            const varNameLower = `{${template.actionKey.toLowerCase()}Amount}`;
                            const varNameUpper = `{${actionKeyCapitalized}Amount}`;
                            const formattedAmount = formatNumberBySettings(customAmount);
                            result = result
                                .replace(new RegExp(varName.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount)
                                .replace(new RegExp(varNameLower.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount)
                                .replace(new RegExp(varNameUpper.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount);
                        }
                    });
                }
                
                // Кошельки: подстановка адресов и QR (важно для шаблонов комиссии/верификации и т.д.)
                return result
                .replace(/\{mainWalletAddress\}/g, mainWalletAddress)
                .replace(/\{commissionWalletAddress\}/g, commissionWalletAddress)
                .replace(/\{commissionWalletQr\}/g, commissionWalletQr)
                .replace(/\{verificationWalletAddress\}/g, verificationWalletAddress)
                .replace(/\{verificationWalletQr\}/g, verificationWalletQr)
                .replace(/\{taxWalletAddress\}/g, taxWalletAddress)
                .replace(/\{taxWalletQr\}/g, taxWalletQr)
                .replace(/\{cryptoConversionWalletAddress\}/g, cryptoConversionWalletAddress)
                .replace(/\{cryptoConversionWalletQr\}/g, cryptoConversionWalletQr)
                .replace(/\{bankConversionWalletAddress\}/g, bankConversionWalletAddress)
                .replace(/\{bankConversionWalletQr\}/g, bankConversionWalletQr);
            };

            const currentUser = getCurrentUser();
            const emailData = {
                to: userEmail,
                subject: process(subject),
                html: tpl.type === 'html' ? process(tpl.html || '') : undefined,
                templateData: { userName: normalizedUserName, userEmail, bankAccount, bank, currencySymbol, message: process(text) },
                configFile: currentConfigFile,
                templateId: tpl.id,
                templateName: tpl.name,
                fromDomain: tpl.fromDomain || undefined,
                sentBy: currentUser?.username || null,
                sentBySapId: currentUser?.id || null
            };

            console.log('[CLIENT] Отправка письма через action:', actionKey, 'на', userEmail);
            
            try {
                const resp = await fetch('/api/config/email/send', { 
                    method: 'POST', 
                    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, 
                    body: JSON.stringify(emailData) 
                });
                
                if (!resp) {
                    throw new Error('Не удалось получить ответ от сервера');
                }
                
                if (!resp.ok && resp.status === 0) {
                    throw new Error('Не удалось подключиться к серверу. Убедитесь, что сервер запущен на порту 3002.');
                }
                
                // Проверяем тип ответа
                const contentType = resp.headers.get('content-type');
                if (!contentType || !contentType.includes('application/json')) {
                    const text = await resp.text();
                    console.error('[CLIENT] Сервер вернул не JSON:', text.substring(0, 200));
                    notifyError('Ошибка отправки письма: сервер вернул неверный формат ответа. Убедитесь, что сервер запущен и перезапущен после изменений.');
                    return;
                }
                
            const result = await resp.json();
                console.log('[CLIENT] Ответ от сервера:', result);
                
            if (resp.ok && result.success) {
                auditAdmin('send_action_email_success', 'Письмо второй линии отправлено', {
                    actionKey,
                    response: result
                });
                try { window.dispatchEvent(new CustomEvent('app:toast', { detail: { type: 'success', message: 'Письмо отправлено' } })); } catch(_) {}
                const nextLog = { ...(record.sentLog || {}) };
                nextLog[actionKey] = { sent: true, at: formatMoscow(), atDisplay: formatDateTimeForEmails(), atISO: new Date().toISOString() };
                    const { saveLocalUser } = await import('../../utils/userUtils');
                    await saveLocalUser({ mode: 'update', id: record.id, ...record, name: normalizedUserName, email: userEmail, cryptoAddress: bankAccount, selectedBank: bank, sentLog: nextLog, timestamp: record.timestamp });
                await loadSavedUsers();
            } else {
                auditAdmin('send_action_email_error', 'Ошибка отправки письма второй линии', {
                    actionKey,
                    response: result
                });
                notifyError('Ошибка отправки письма: ' + (result?.error || ''));
                }
            } catch (fetchErr) {
                console.error('[CLIENT] Ошибка fetch:', fetchErr);
                auditAdmin('send_action_email_error', 'Ошибка запроса отправки письма второй линии', {
                    actionKey,
                    error: fetchErr.message
                });
                notifyError('Ошибка отправки письма: ' + fetchErr.message + '\n\nУбедитесь, что сервер запущен на порту 3002.');
            }
        } catch (e) {
            console.error('[CLIENT] Общая ошибка отправки письма:', e);
            auditAdmin('send_action_email_error', 'Общая ошибка отправки письма второй линии', {
                actionKey,
                error: e.message
            });
            notifyError('Ошибка отправки письма: ' + e.message);
        }
    };

    // Функция для получения иконки тарифа
    const getTariffIcon = (tariffLabel) => {
        switch(tariffLabel) {
            case '💰 1 ТАРИФ': return tarif1Icon;
            case '❗❗ 2 ТАРИФ': return tarif2Icon;
            case '❗❗❗ 3 ТАРИФ': return tarif3Icon;
            case '❗❗❗❗ 4 ТАРИФ': return tarif4Icon;
            case '⚠️ VIP ТАРИФ': return viptarifIcon;
            default: return tarif1Icon;
        }
    };

    const addTransaction = () => {
        setTransactions((prevTransactions) => [
            {
                id: Math.floor(Math.random() * 1000000),
                type: `Transfer ${currencyFormat || 'RM'}`,
                amount: `${currencyFormat || 'RM'} ${maxTotalMoney.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
                status: 'fixed',
                action: 'Betulkan sekarang',
                image: telegram,
                description: `to ${cryptoAdress}`,
            },
            ...prevTransactions,
        ]);
    };

    const removeTransaction = () => {
        setTransactions((prevTransactions) => prevTransactions.slice(1));
    };

    // Состояние для анимации закрытия
    const [isClosing, setIsClosing] = useState(false);

    // Функция для плавного закрытия (мемоизированная)
    const handleClose = useCallback(() => {
        if (isClosing) return; // Предотвращаем повторные вызовы
        
        setIsClosing(true);
        
        // Ждем завершения анимации и затем закрываем панель
        setTimeout(() => {
            setAdminPanel(false);
            setIsClosing(false);
        }, 300); // 300ms соответствует длительности анимации
    }, [isClosing, setAdminPanel]);

    // Nova: пока админка открыта, модалы центрируются в свободном
    // пространстве слева от неё — панель становится «краем» вьюпорта
    // (оверлеи модалов читают --nova-admin-edge как доп. правый паддинг).
    // Переменная снимается сразу на старте закрытия (isClosing), чтобы
    // модал плавно съехал в центр приложения параллельно с уходящей панелью.
    useEffect(() => {
        if (typeof document === 'undefined') return;
        const root = document.documentElement;
        const isOpen = isNovaTheme && adminPanel && !isClosing && window.innerWidth > 768;
        try {
            if (isOpen) {
                root.style.setProperty('--nova-admin-edge', '316px');
            } else {
                root.style.removeProperty('--nova-admin-edge');
            }
        } catch (_) {}
        return () => {
            try { root.style.removeProperty('--nova-admin-edge'); } catch (_) {}
        };
    }, [isNovaTheme, adminPanel, isClosing]);

    // Восстанавливаем последнюю позицию прокрутки при каждом открытии.
    // Рендер панели может быть отложен (портал ждёт корень Nova после смены
    // темы), поэтому дожидаемся элемента через rAF с ограничением попыток
    const adminContentRef = useRef(null);
    useEffect(() => {
        if (!adminPanel) return;
        let raf = 0;
        let tries = 0;
        const restore = () => {
            const el = adminContentRef.current;
            if (el) {
                el.scrollTop = adminScrollMemory;
                return;
            }
            if (tries++ < 30) raf = requestAnimationFrame(restore);
        };
        restore();
        return () => cancelAnimationFrame(raf);
    }, [adminPanel]);

    // Сброс состояния при открытии панели
    useEffect(() => {
        if (adminPanel) {
            setIsClosing(false);
            // Устанавливаем флаг, что админка только что открылась
            adminPanelJustToggled.current = true;
            // Сбрасываем флаг через 1000мс после открытия (увеличено для надежности)
            setTimeout(() => {
                adminPanelJustToggled.current = false;
            }, 1000);
            // Убеждаемся, что секция "Данные" развернута при открытии
            setCollapsed(prev => ({ ...prev, user: false }));
            // Убеждаемся, что мини-поле имени видно при открытии (на случай если секция свернута)
            setUserMiniVisible(prev => ({ ...prev, name: true }));
            // Убираем фокус с любого поля при открытии админки, чтобы избежать автоматической очистки
            if (document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA')) {
                document.activeElement.blur();
            }
        } else {
            // При закрытии тоже устанавливаем флаг
            adminPanelJustToggled.current = true;
            setTimeout(() => {
                adminPanelJustToggled.current = false;
            }, 1000);
        }
    }, [adminPanel]);

    // Закрытие админ панели при клике вне её области
    useEffect(() => {
        const isOtzovikMode = siteSettings?.otzovikMode || false;
        
        // В режиме отзовика не закрываем админку по клику вне её
        if (isOtzovikMode) return;
        
        // Если галочка "Автоматически сворачивать админку" выключена - не закрываем по клику вне
        if (!autoCloseOnClickOutside) return;
        
        const handleAdminPanelClickOutside = (event) => {
            if (saveDialog.open) return; // не закрываем админку, когда открыт глобальный модал
            // Открыта минифигма — закрытие поэтапное: этот клик закрывает её,
            // а админка закроется только следующим кликом вне
            if (document.documentElement.hasAttribute('data-figma-open')) return;
            // Проверяем, что клик был вне админ панели
            const isAdminPanelClick = event.target.closest('[class*="adminPanel"]') || 
                                     event.target.closest('[class*="adminOverlay"]') ||
                                     // Шит минифигмы открыт поверх админки — клики в нём не закрывают её
                                     event.target.closest('[data-figma-sheet]');
            
            if (!isAdminPanelClick && adminPanel) {
                // Открыт модал: закрытие поэтапное — этот клик закрывает
                // только админку, а модал остаётся (его закроет следующий).
                // Помечаем клик «израсходованным»: оверлеи модалов проверяют
                // атрибут в своём onClick и пропускают этот клик
                if (anyModalOpen) {
                    const root = document.documentElement;
                    root.setAttribute('data-admin-consumed-click', '');
                    const clear = () => root.removeAttribute('data-admin-consumed-click');
                    // Убираем метку после того, как отработает click этого же
                    // жеста (window-слушатель сработает после хендлера модала);
                    // страховочный таймер — если click так и не случится
                    window.addEventListener('click', () => setTimeout(clear, 0), { once: true });
                    setTimeout(clear, 600);
                }
                // Используем ту же анимацию, что и при нажатии на крестик
                handleClose();
            }
        };

        // Добавляем слушатель только когда админ панель открыта
        if (adminPanel && !saveDialog.open) {
            // Небольшая задержка, чтобы избежать немедленного закрытия при открытии
            const timer = setTimeout(() => {
                document.addEventListener('mousedown', handleAdminPanelClickOutside);
            }, 100);
            
            return () => {
                clearTimeout(timer);
                document.removeEventListener('mousedown', handleAdminPanelClickOutside);
            };
        }
    }, [adminPanel, setAdminPanel, handleClose, saveDialog.open, siteSettings?.otzovikMode, autoCloseOnClickOutside, anyModalOpen]);

    // Синхронизируем selectedConfig с currentConfigFile при изменении currentConfigFile
    useEffect(() => {
        if (currentConfigFile && currentConfigFile !== selectedConfig) {
            setSelectedConfig(currentConfigFile);
        }
    }, [currentConfigFile, selectedConfig]);

    // Показываем компонент, если админка открыта ИЛИ если идет анимация закрытия
    if (!adminPanel && !isClosing) return null;

    // Отправка регистрационного письма для текущих данных пользователя
    const handleSendRegistrationEmail = async () => {
        try {
            const record = getCurrentUserRecord() || {};
            auditAdmin('send_registration_email_attempt', 'Попытка отправки регистрационного письма', {
                record
            });
            // Запрашиваем шаблоны и ищем отмеченный для регистрации
            const tplRes = await fetch((window.location && window.location.origin ? window.location.origin : '') + '/api/config/templates/');
            const tplData = await tplRes.json();
            const templates = Array.isArray(tplData.templates) ? tplData.templates : [];
            // Используем selectedConfig или currentConfigFile как fallback
            const activeCfg = selectedConfig || currentConfigFile || '';
            // Ищем шаблон с учетом allowedConfigs (без fallback, который игнорирует фильтр)
            const regTpl = templates.find(t => {
                if (!t.useOnRegistration) return false;
                // Если allowedConfigs не задан или пустой - шаблон доступен для всех конфигов
                if (!t.allowedConfigs || t.allowedConfigs.length === 0) return true;
                // Если allowedConfigs задан - проверяем, что текущий конфиг в списке
                return t.allowedConfigs.includes(activeCfg);
            });
            if (!regTpl) {
                notifyError('Не найден шаблон, отмеченный для регистрации' + (activeCfg ? ' (конфиг: ' + activeCfg + ')' : ' (конфиг не выбран)'));
                return;
            }

            const verificationCode = String(Math.floor(100000 + Math.random() * 900000));
            const currencySymbol = siteSettings?.currencyFormat || '$';
            const bankAccount = cryptoAdress?.trim() || '';
            const bankFromSaved = (savedUsers || []).find(u => (u.email && u.email === userEmail) || (u.name && u.name === nameUser))?.selectedBank || '';
            const bank = (network?.name || imgCoin?.name || bankFromSaved || '').trim();
            const bankInfo = siteSettings?.banks?.[bank];
            const baseOriginRaw = siteSettings?.publicBaseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
            const baseOrigin = (baseOriginRaw || '').startsWith('http://') ? baseOriginRaw.replace('http://', 'https://') : (baseOriginRaw || '');
            const bankIconUrl = bankInfo?.iconUrl || (bankInfo?.iconFileName ? `/bankicons/${bankInfo.iconFileName}` : '');
            const subject = (regTpl.subject || '');
            const text = (regTpl.content || regTpl.html || '');

            // Недостающие значения для подстановки по тому же принципу, что и в других отправках
            const defaultCrypto = selectedCrypto || siteSettings?.defaultCrypto || '';
            const depositAmountVal = getDepositForCurrentTariff();
            const userWinningVal = Number(maxTotalMoney) || 0;
            const userWinningPercentVal = getWinningPercentForTariff(userWinningVal, depositAmountVal);

            const {
                mainWalletAddress,
                commissionWalletAddress,
                commissionWalletQr,
                verificationWalletAddress,
                verificationWalletQr,
                taxWalletAddress,
                taxWalletQr,
                cryptoConversionWalletAddress,
                cryptoConversionWalletQr,
                bankConversionWalletAddress,
                bankConversionWalletQr
            } = getEmailWalletVariables(siteSettings, defaultCrypto, cryptoOptions);

            const normalizedUserName = normalizePersonName(nameUser || '');
            const process = (str) => {
                let result = (str || '')
                .replace(/\{userName\}/g, normalizedUserName || 'Пользователь')
                .replace(/\{userEmail\}/g, userEmail || '')
                .replace(/\{bankAccount\}/g, bankAccount)
                .replace(/\{cryptoAddress\}/g, bankAccount)
                .replace(/\{bank\}/g, bank)
                .replace(/\{selectedBank\}/g, bank)
                .replace(/\{bankIconUrl\}/g, bankIconUrl)
                .replace(/\{currentTime\}/g, formatDateTimeForEmails())
                .replace(/\{currencySymbol\}/g, currencySymbol)
                .replace(/\{verificationCode\}/g, verificationCode)
                .replace(/\{defaultCrypto\}/g, defaultCrypto)
                .replace(/\{depositAmount\}/g, formatNumberBySettings(depositAmountVal))
                .replace(/\{userWinning\}/g, formatNumberBySettings(userWinningVal))
                .replace(/\{userWinningPercent\}/g, `${formatNumberBySettings(userWinningPercentVal, 0, 1)}%`)
                    .replace(/\{userWinningPlusAdditional\}/g, formatNumberBySettings((Number(userWinningVal)||0) + (Number(getAmountValue('tariffAdditionalAmount', currentTariff))||0)))
                    .replace(/\{commissionAmount\}/g, formatNumberBySettings(getAmountValue('tariffCommission', currentTariff)))
                .replace(/\{commissionPercent\}/g, (() => {
                    const winNum = Number(userWinningVal) || 0;
                        const commNum = Number(getAmountValue('tariffCommission', currentTariff)) || 0;
                    const pct = winNum > 0 ? (commNum / winNum) * 100 : 0;
                    return `${formatNumberBySettings(pct, 1, 1)}%`;
                })())
                    .replace(/\{verificationAmount\}/g, formatNumberBySettings(getAmountValue('tariffVerificationAmount', currentTariff)))
                    .replace(/\{additionalAmount\}/g, formatNumberBySettings(getAmountValue('tariffAdditionalAmount', currentTariff)))
                    .replace(/\{taxPercent\}/g, `${formatNumberBySettings(getAmountValue('tariffTaxPercent', currentTariff), 0, 2)}%`);
                
                // Добавляем переменные для кастомных модалов
                if (siteSettings?.modalTemplates) {
                    siteSettings.modalTemplates.forEach(template => {
                        if (template.financeFieldName && template.actionKey) {
                            const actionKeyCapitalized = template.actionKey.charAt(0).toUpperCase() + template.actionKey.slice(1);
                            const settingsKey = `tariff${actionKeyCapitalized}Amounts`;
                            const rangesKey = `${settingsKey}Ranges`;
                            const fieldKey = `tariff${actionKeyCapitalized}Amount`;
                            
                            // Получаем сумму для кастомного модала
                            let customAmount = 0;
                            const useGenerated = siteSettings?.randomizeRanges && !siteSettings?.otzovikMode;
                            const currentUser = getCurrentUser();
                            if (useGenerated && currentUser?.generatedAmounts?.[fieldKey] !== undefined && currentUser.generatedAmounts[fieldKey] !== null) {
                                customAmount = currentUser.generatedAmounts[fieldKey];
                            } else {
                                const fixedAmount = siteSettings?.[settingsKey]?.[currentTariff];
                                if (fixedAmount !== undefined && fixedAmount !== null && fixedAmount !== 0) {
                                    customAmount = fixedAmount;
                                } else {
                                    const ranges = siteSettings?.[rangesKey]?.[currentTariff];
                                    if (ranges && ranges.min !== undefined && ranges.max !== undefined) {
                                        if (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode) {
                                            customAmount = ranges.min + Math.random() * (ranges.max - ranges.min);
                                        } else {
                                            customAmount = (ranges.min + ranges.max) / 2;
                                        }
                                    }
                                }
                            }
                            
                            // Добавляем переменные: {actionKeyAmount}, {actionKeyAmountLower}, {actionKeyAmountUpper}
                            const varName = `{${template.actionKey}Amount}`;
                            const varNameLower = `{${template.actionKey.toLowerCase()}Amount}`;
                            const varNameUpper = `{${actionKeyCapitalized}Amount}`;
                            const formattedAmount = formatNumberBySettings(customAmount);
                            result = result
                                .replace(new RegExp(varName.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount)
                                .replace(new RegExp(varNameLower.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount)
                                .replace(new RegExp(varNameUpper.replace(/[{}]/g, '\\$&'), 'gi'), formattedAmount);
                        }
                    });
                }
                
                return result
                    .replace(/\{conversionFee\}/g, formatNumberBySettings(getAmountValue('tariffConversionCommission', currentTariff)))
                    .replace(/\{bankFee\}/g, formatNumberBySettings(getAmountValue('tariffBankFee', currentTariff)))
                    .replace(/\{brokerFee\}/g, formatNumberBySettings(getAmountValue('tariffBrokerFee', currentTariff)))
                // Кошельки
                .replace(/\{mainWalletAddress\}/g, mainWalletAddress)
                .replace(/\{commissionWalletAddress\}/g, commissionWalletAddress)
                .replace(/\{commissionWalletQr\}/g, commissionWalletQr)
                .replace(/\{verificationWalletAddress\}/g, verificationWalletAddress)
                .replace(/\{verificationWalletQr\}/g, verificationWalletQr)
                .replace(/\{taxWalletAddress\}/g, taxWalletAddress)
                .replace(/\{taxWalletQr\}/g, taxWalletQr)
                .replace(/\{cryptoConversionWalletAddress\}/g, cryptoConversionWalletAddress)
                .replace(/\{cryptoConversionWalletQr\}/g, cryptoConversionWalletQr)
                .replace(/\{bankConversionWalletAddress\}/g, bankConversionWalletAddress)
                .replace(/\{bankConversionWalletQr\}/g, bankConversionWalletQr);
            };

            const currentUser = getCurrentUser();
            const emailData = {
                to: userEmail,
                subject: process(subject),
                html: regTpl.type === 'html' ? process(regTpl.html || '') : undefined,
                templateData: {
                    userName: normalizedUserName,
                    userEmail,
                    bankAccount,
                    bank,
                    currencySymbol,
                    verificationCode,
                    message: process(text)
                },
                configFile: currentConfigFile,
                templateId: regTpl.id,
                templateName: regTpl.name,
                fromDomain: regTpl.fromDomain || undefined,
                sentBy: currentUser?.username || null,
                sentBySapId: currentUser?.id || null
            };

            const resp = await fetch((window.location && window.location.origin ? window.location.origin : '') + '/api/config/email/send', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
                body: JSON.stringify(emailData)
            }).catch(err => {
                console.error('Ошибка fetch:', err);
                throw new Error('Не удалось отправить запрос: ' + err.message);
            });
            
            if (!resp.ok && resp.status === 0) {
                throw new Error('Не удалось подключиться к серверу. Убедитесь, что сервер запущен на порту 3002.');
            }
            
            // Проверяем тип ответа
            const contentType = resp.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                const text = await resp.text();
                console.error('Сервер вернул не JSON:', text.substring(0, 200));
                notifyError('Ошибка отправки письма: сервер вернул неверный формат ответа. Убедитесь, что сервер запущен и перезапущен после изменений.');
                return;
            }
            
            const result = await resp.json();
            if (resp.ok && result.success) {
                auditAdmin('send_registration_email_success', 'Регистрационное письмо отправлено', {
                    response: result,
                    template: regTpl,
                    verificationCode
                });
                if (window && window.dispatchEvent) {
                    try { window.dispatchEvent(new CustomEvent('app:toast', { detail: { type: 'success', message: 'Регистрационное письмо отправлено' } })); } catch(_) {}
                }
                // Обновим чекпоинт и лог
                const nextLog = { ...getEffectiveSentLog(record), registration: { sent: true, at: formatMoscow(), atDisplay: formatDateTimeForEmails(), atISO: new Date().toISOString(), verificationCode } };
                const { saveLocalUser } = await import('../../utils/userUtils');
                await saveLocalUser({ mode: 'update', id: record.id, ...record, name: normalizedUserName, email: userEmail, cryptoAddress: bankAccount, selectedBank: bank, checkpoint: 2, sentLog: nextLog, timestamp: record.timestamp });
                await loadSavedUsers();
            } else {
                auditAdmin('send_registration_email_error', 'Ошибка отправки регистрационного письма', {
                    response: result
                });
                notifyError('Ошибка отправки письма: ' + (result?.error || ''));
            }
        } catch (e) {
            auditAdmin('send_registration_email_error', 'Ошибка отправки регистрационного письма', {
                error: e.message
            });
            notifyError('Ошибка отправки письма: ' + e.message);
        }
    };

    // Отправка письма успеха (после регистрации)
    const handleSendSuccessEmail = async () => {
        try {
            const record = getCurrentUserRecord() || {};
            auditAdmin('send_success_email_attempt', 'Попытка отправки письма успеха', {
                record
            });
            const tplRes = await fetch('/api/config/templates/');
            const tplData = await tplRes.json();
            const templates = Array.isArray(tplData.templates) ? tplData.templates : [];
            // Используем selectedConfig или currentConfigFile как fallback
            const activeCfg = selectedConfig || currentConfigFile || '';
            const successTpl = templates.find(t => {
                if (!t.useOnSuccess) return false;
                // Если allowedConfigs не задан или пустой - шаблон доступен для всех конфигов
                if (!t.allowedConfigs || t.allowedConfigs.length === 0) return true;
                // Если allowedConfigs задан - проверяем, что текущий конфиг в списке
                return t.allowedConfigs.includes(activeCfg);
            });
            if (!successTpl) { 
                notifyError('Не найден шаблон для письма успеха' + (activeCfg ? ' (конфиг: ' + activeCfg + ')' : ' (конфиг не выбран)')); 
                return; 
            }

            const currencySymbol = siteSettings?.currencyFormat || '$';
            const bankAccount = cryptoAdress?.trim() || '';
            const bankFromSaved = (savedUsers || []).find(u => (u.email && u.email === userEmail) || (u.name && u.name === nameUser))?.selectedBank || '';
            const bank = (network?.name || imgCoin?.name || bankFromSaved || '').trim();
            const bankInfo = siteSettings?.banks?.[bank];
            const baseOriginRaw = siteSettings?.publicBaseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
            const baseOrigin = (baseOriginRaw || '').startsWith('http://') ? baseOriginRaw.replace('http://', 'https://') : (baseOriginRaw || '');
            const bankIconUrl = bankInfo?.iconUrl || (bankInfo?.iconFileName ? `/bankicons/${bankInfo.iconFileName}` : '');
            const subject = (successTpl.subject || '');
            const text = (successTpl.content || successTpl.html || '');
            const depositAmountVal2 = getDepositForCurrentTariff();
            const userWinningVal2 = Number(maxTotalMoney) || 0;
            const userWinningPercentVal2 = getWinningPercentForTariff(userWinningVal2, depositAmountVal2);
            const normalizedUserName = normalizePersonName(nameUser || '');

            // Добавим генерацию/сохранение TX для пользователя при успехе
            const ensureTxId = (user) => {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                const gen = () => {
                    let r = 'TX';
                    for (let i = 0; i < 6; i++) r += chars[Math.floor(Math.random()*chars.length)];
                    return r;
                };
                if (!user.txId) user.txId = gen();
                return user.txId;
            };

            const txId = ensureTxId(record);

            // Получаем verificationCode из предыдущего регистрационного письма, если есть
            const verificationCode = record?.sentLog?.registration?.verificationCode || '';
            const defaultCrypto = selectedCrypto || siteSettings?.defaultCrypto || '';
            
            const {
                mainWalletAddress,
                commissionWalletAddress,
                commissionWalletQr,
                verificationWalletAddress,
                verificationWalletQr,
                taxWalletAddress,
                taxWalletQr,
                cryptoConversionWalletAddress,
                cryptoConversionWalletQr,
                bankConversionWalletAddress,
                bankConversionWalletQr
            } = getEmailWalletVariables(siteSettings, defaultCrypto, cryptoOptions);
            
            const process = (str) => (str || '')
                .replace(/\{userName\}/g, normalizedUserName || 'Пользователь')
                .replace(/\{userEmail\}/g, userEmail || '')
                .replace(/\{bankAccount\}/g, bankAccount)
                .replace(/\{cryptoAddress\}/g, bankAccount)
                .replace(/\{bank\}/g, bank)
                .replace(/\{selectedBank\}/g, bank)
                .replace(/\{bankIconUrl\}/g, bankIconUrl)
                .replace(/\{currentTime\}/g, formatDateTimeForEmails())
                .replace(/\{currencySymbol\}/g, currencySymbol)
                .replace(/\{verificationCode\}/g, verificationCode)
                .replace(/\{defaultCrypto\}/g, defaultCrypto)
                .replace(/\{depositAmount\}/g, formatNumberBySettings(depositAmountVal2))
                .replace(/\{userWinning\}/g, formatNumberBySettings(userWinningVal2))
                .replace(/\{userWinningPercent\}/g, `${formatNumberBySettings(userWinningPercentVal2, 1, 1)}%`)
                .replace(/\{userWinningPlusAdditional\}/g, formatNumberBySettings((Number(userWinningVal2)||0) + (Number(getAmountValue('tariffAdditionalAmount', currentTariff))||0)))
                .replace(/\{commissionAmount\}/g, formatNumberBySettings(getAmountValue('tariffCommission', currentTariff)))
                .replace(/\{commissionPercent\}/g, (() => {
                    const winNum = Number(userWinningVal2) || 0;
                    const commNum = Number(getAmountValue('tariffCommission', currentTariff)) || 0;
                    const pct = winNum > 0 ? (commNum / winNum) * 100 : 0;
                    return `${formatNumberBySettings(pct, 1, 1)}%`;
                })())
                .replace(/\{verificationAmount\}/g, formatNumberBySettings(getAmountValue('tariffVerificationAmount', currentTariff)))
                .replace(/\{additionalAmount\}/g, formatNumberBySettings(getAmountValue('tariffAdditionalAmount', currentTariff)))
                .replace(/\{taxPercent\}/g, `${formatNumberBySettings(getAmountValue('tariffTaxPercent', currentTariff), 0, 2)}%`)
                .replace(/\{conversionFee\}/g, formatNumberBySettings(getAmountValue('tariffConversionCommission', currentTariff)))
                .replace(/\{bankFee\}/g, formatNumberBySettings(getAmountValue('tariffBankFee', currentTariff)))
                .replace(/\{brokerFee\}/g, formatNumberBySettings(getAmountValue('tariffBrokerFee', currentTariff)))
                // Кошельки
                .replace(/\{mainWalletAddress\}/g, mainWalletAddress)
                .replace(/\{commissionWalletAddress\}/g, commissionWalletAddress)
                .replace(/\{commissionWalletQr\}/g, commissionWalletQr)
                .replace(/\{verificationWalletAddress\}/g, verificationWalletAddress)
                .replace(/\{verificationWalletQr\}/g, verificationWalletQr)
                .replace(/\{taxWalletAddress\}/g, taxWalletAddress)
                .replace(/\{taxWalletQr\}/g, taxWalletQr)
                .replace(/\{cryptoConversionWalletAddress\}/g, cryptoConversionWalletAddress)
                .replace(/\{cryptoConversionWalletQr\}/g, cryptoConversionWalletQr)
                .replace(/\{bankConversionWalletAddress\}/g, bankConversionWalletAddress)
                .replace(/\{bankConversionWalletQr\}/g, bankConversionWalletQr);

            const currentUser = getCurrentUser();
            const emailData = {
                to: userEmail,
                subject: process(subject),
                html: successTpl.type === 'html' ? process(successTpl.html || '') : undefined,
                text: successTpl.type === 'text' ? process(successTpl.content || '') : undefined,
                templateData: { userName: normalizedUserName, userEmail, bankAccount, bank, currencySymbol, message: process(text), txId },
                configFile: currentConfigFile,
                templateId: successTpl.id,
                templateName: successTpl.name,
                fromDomain: successTpl.fromDomain || undefined,
                sentBy: currentUser?.username || null,
                sentBySapId: currentUser?.id || null
            };
            const resp = await fetch('/api/config/email/send', { 
                method: 'POST', 
                headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, 
                body: JSON.stringify(emailData) 
            }).catch(err => {
                console.error('Ошибка fetch:', err);
                throw new Error('Не удалось отправить запрос: ' + err.message);
            });
            
            if (!resp.ok && resp.status === 0) {
                throw new Error('Не удалось подключиться к серверу. Убедитесь, что сервер запущен на порту 3002.');
            }
            
            // Проверяем тип ответа
            const contentType = resp.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                const text = await resp.text();
                console.error('Сервер вернул не JSON:', text.substring(0, 200));
                notifyError('Ошибка отправки письма: сервер вернул неверный формат ответа. Убедитесь, что сервер запущен и перезапущен после изменений.');
                return;
            }
            
            const result = await resp.json();
            if (resp.ok && result.success) {
                auditAdmin('send_success_email_success', 'Письмо успеха отправлено', {
                    response: result,
                    template: successTpl,
                    txId
                });
                try { window.dispatchEvent(new CustomEvent('app:toast', { detail: { type: 'success', message: 'Письмо успеха отправлено' } })); } catch(_) {}
                const nextLog = { ...getEffectiveSentLog(record), successFirst: { sent: true, at: formatMoscow(), atDisplay: formatDateTimeForEmails(), atISO: new Date().toISOString(), txId } };
                const { saveLocalUser } = await import('../../utils/userUtils');
                await saveLocalUser({ mode: 'update', id: record.id, ...record, txId, name: normalizedUserName, email: userEmail, cryptoAddress: bankAccount, selectedBank: bank, checkpoint: 3, sentLog: nextLog, timestamp: record.timestamp });
                await loadSavedUsers();
            } else {
                auditAdmin('send_success_email_error', 'Ошибка отправки письма успеха', {
                    response: result
                });
                notifyError('Ошибка отправки письма: ' + (result?.error || ''));
            }
        } catch (e) {
            auditAdmin('send_success_email_error', 'Ошибка отправки письма успеха', {
                error: e.message
            });
            notifyError('Ошибка отправки письма: ' + e.message);
        }
    };

    const renderSaveDialog = () => {
        if (!saveDialog?.open) return null;
        const existing = saveDialog.existing || {};
        const next = saveDialog.newData || {};
        const closeDialog = () => setSaveDialog({ open: false, existing: null, newData: null });

        const node = isNovaTheme ? (() => {
            // Сравнение по полям: наглядно видно, что именно изменится
            const fields = [
                { key: 'name', label: 'Имя', oldV: existing.name || '', newV: next.name || '' },
                { key: 'email', label: 'E-Mail', oldV: existing.email || '', newV: next.email || '' },
                { key: 'account', label: 'Счёт', oldV: existing.cryptoAddress || '', newV: next.cryptoAddress || '' },
            ];
            return (
                <div className={`${s.globalModalOverlay} ${s.novaDialog}`} onMouseDown={(e) => { if (e.target === e.currentTarget) closeDialog(); }}>
                    <div className={s.dupCard} role="alertdialog" aria-modal="true" aria-label="Найден дубликат пользователя">
                        <div className={s.dupHeader}>
                            <div className={s.dupIcon}><Users size={20} strokeWidth={2} aria-hidden="true" /></div>
                            <div className={s.dupHeadText}>
                                <div className={s.dupTitle}>Найден дубликат пользователя</div>
                                <div className={s.dupSub}>Такой пользователь уже есть в базе — сравните данные и выберите действие</div>
                            </div>
                            <button type="button" className={s.dupClose} onClick={closeDialog}>
                                <XIcon size={15} strokeWidth={2.2} aria-hidden="true" />
                            </button>
                        </div>
                        <div className={s.dupTable}>
                            <div className={s.dupTableHead}>
                                <span>Поле</span><span>В базе</span><span /><span>Станет</span>
                            </div>
                            {fields.map((f) => {
                                const changed = (f.oldV || '') !== (f.newV || '');
                                return (
                                    <div key={f.key} className={s.dupRow}>
                                        <span className={s.dupField}>{f.label}</span>
                                        <span className={s.dupOld}>{f.oldV || '—'}</span>
                                        <ArrowRight size={14} strokeWidth={2.2} className={`${s.dupArrow} ${changed ? s.dupArrowOn : ''}`} aria-hidden="true" />
                                        <span className={`${s.dupNew} ${changed ? s.dupChanged : ''}`}>{changed ? (f.newV || '—') : 'без изменений'}</span>
                                    </div>
                                );
                            })}
                        </div>
                        <div className={s.dupActions}>
                            <button type="button" className={s.dupBtnGhost} data-hint="Создаст отдельную новую запись, старая останется" onClick={(e) => { e.preventDefault(); e.stopPropagation(); doSaveWithMode('new', saveDialog.newData); }}>
                                <UserPlus size={14} strokeWidth={2.1} aria-hidden="true" /> Как нового
                            </button>
                            <button type="button" className={s.dupBtnPrimary} data-hint="Обновит данные, прогресс сохранится: чекпоинт и отправленные письма останутся как были" onClick={(e) => { e.preventDefault(); e.stopPropagation(); doSaveWithMode('update', saveDialog.newData, saveDialog.existing); }}>
                                <RefreshCw size={14} strokeWidth={2.1} aria-hidden="true" /> Обновить
                            </button>
                            <button type="button" className={s.dupBtnDanger} data-hint="Обновит данные и сбросит прогресс: чекпоинт вернётся на старт, письма можно слать заново" onClick={(e) => { e.preventDefault(); e.stopPropagation(); doSaveWithMode('replace', saveDialog.newData, saveDialog.existing); }}>
                                <Replace size={14} strokeWidth={2.1} aria-hidden="true" /> Заменить
                            </button>
                        </div>
                    </div>
                </div>
            );
        })() : (
            <div className={s.globalModalOverlay} onMouseDown={(e) => { if (e.target === e.currentTarget) closeDialog(); }}>
                <div className={s.globalModal}>
                    <div className={s.globalModalHeader}>
                        <div className={s.globalModalTitle}>Найден дубликат пользователя</div>
                        <button type="button" className={s.globalModalClose} onClick={closeDialog} title="Закрыть окно, ничего не сохраняя">
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    <div className={s.globalModalBody}>Такой пользователь уже есть в базе. Выберите, что сделать:</div>
                    <div className={s.globalModalBox}>
                        <div><strong>Существующий:</strong> {(existing.name || '')} · {(existing.email || '')} · {(existing.cryptoAddress || '')}</div>
                        <div style={{ marginTop: 8 }}><strong>Новые данные:</strong> {(next.name || '')} · {(next.email || '')} · {(next.cryptoAddress || '')}</div>
                    </div>
                    <div className={s.globalModalActions}>
                        <button type="button" className={s.modalSecondary} title="Создаст отдельную новую запись, существующий пользователь останется без изменений" onClick={(e) => { e.preventDefault(); e.stopPropagation(); doSaveWithMode('new', saveDialog.newData); }}>Сохранить как нового</button>
                        <button type="button" className={s.modalPrimary} title="Обновит данные, прогресс сохранится: чекпоинт и отправленные письма останутся как были" onClick={(e) => { e.preventDefault(); e.stopPropagation(); doSaveWithMode('update', saveDialog.newData, saveDialog.existing); }}><IconSave size={14}/> Обновить существующего</button>
                        <button type="button" className={s.modalDanger} title="Обновит данные и сбросит прогресс: чекпоинт вернётся на старт, письма можно слать заново" onClick={(e) => { e.preventDefault(); e.stopPropagation(); doSaveWithMode('replace', saveDialog.newData, saveDialog.existing); }}>Заменить</button>
                    </div>
                </div>
            </div>
        );
        const novaRoot = isNovaTheme ? document.querySelector('[data-nova-theme]') : null;
        return ReactDOM.createPortal(node, novaRoot || document.body);
    };

    const panelNode = (
        <>
        {isNovaTheme && (adminPanel || isClosing) && (
            <div className={`${s.novaBackdrop} ${isClosing ? s.closing : ''} ${(anyModalOpen && !modalLeaving) ? s.suppressed : ''}`} data-capture-exclude="true" aria-hidden="true" />
        )}
        <div 
            className={`${s.adminOverlay} ${isNovaTheme ? s.novaSkin : ''} ${isClosing ? s.closing : ''}`}
            style={{
                visibility: (!adminPanel && !isClosing) ? 'hidden' : 'visible'
            }}
        >
            <div
                ref={adminPanelRef}
                className={s.adminPanel}
                data-ltr-force
                onBlurCapture={handleAdminBlurCapture}
                onClickCapture={handleAdminClickCapture}
            >
                {/* Header */}
                <div className={s.adminHeader}>
                    <div className={s.headerLeft}>
                        <h2 className={s.adminTitle}>Админка</h2>
                    </div>
                    {isNovaTheme && !siteSettings?.otzovikMode && (
                        <button
                            type="button"
                            className={s.figmaBtn}
                            onClick={() => { try { window.dispatchEvent(new CustomEvent('app:minifigma-open')); } catch (_) {} }}
                        >
                            <LayoutTemplate size={13} strokeWidth={2.1} aria-hidden="true" />
                            Мини-фигма
                        </button>
                    )}
                    {isNovaTheme && (
                        <button
                            type="button"
                            className={s.screenshotBtn}
                            title="Сделать скриншот"
                            aria-label="Сделать скриншот"
                            onClick={() => { try { window.dispatchEvent(new CustomEvent('app:screenshot')); } catch (_) {} }}
                        >
                            <Camera size={15} strokeWidth={2} aria-hidden="true" />
                        </button>
                    )}
                    <button 
                        className={s.closeBtn}
                        onClick={handleClose}
                        aria-label="Close admin panel"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div
                    className={s.adminContent}
                    ref={adminContentRef}
                    onScroll={(e) => { adminScrollMemory = e.currentTarget.scrollTop; }}
                >
                    {(() => {
                        const isOtzovikMode = siteSettings?.otzovikMode || false;
                        
                        if (isOtzovikMode) {
                            // Режим отзовика - специальная структура
                            return (
                                <>
                                    {/* Кнопка перехода в /settings для админов */}
                                    {userRole === 'admin' && (
                                        <div className={s.settingsLinkWrap}>
                                            <button
                                                className={s.settingsLink}
                                                onClick={() => {
                                                    try { localStorage.setItem('nova-return-config', selectedConfig || currentConfigFile || ''); } catch (_) { /* noop */ }
                                                    window.location.href = '/settings';
                                                }}
                                            >
                                                <Settings size={15} strokeWidth={2} aria-hidden="true" />
                                                Перейти в настройки
                                            </button>
                                        </div>
                                    )}
                                    {/* Configuration Management */}
                                    <div className={s.section}>
                                        <div className={s.sectionHeader}>
                                            <div className={s.sectionHeaderLeft}>
                                                <h3 className={s.sectionTitle}>
                                                    <SectionGlyph icon={FolderCog} png={configIcon} alt="Configs" />
                                                    Конфиги
                                                </h3>
                                            </div>
                                            <div className={s.sectionControls}>
                                                <button className={s.iconControlBtn} onClick={() => setCollapsed(prev => ({ ...prev, configs: !prev.configs }))} title="Свернуть"><CollapseGlyph open={!collapsed.configs} /></button>
                                            </div>
                                        </div>
                                        <div className={`${s.sectionBody} ${collapsed.configs ? s.collapsed : ''}`}>
                                            <div className={s.configList}>
                                                {renderConfigPicker()}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Раздел "Данные" - только имя, IBAN, Банк */}
                                    <div className={s.section}>
                                        <div className={s.sectionHeader}>
                                            <div className={s.sectionHeaderLeft}>
                                                <h3 className={s.sectionTitle}>
                                                    <SectionGlyph icon={UserRound} png={userInfoIcon} alt="User Info" />
                                                    Данные
                                                </h3>
                                            </div>
                                            <div className={s.sectionControls}>
                                                <button className={s.iconControlBtn} onClick={() => setCollapsed(prev => ({ ...prev, user: !prev.user }))} title="Свернуть"><CollapseGlyph open={!collapsed.user} /></button>
                                            </div>
                                        </div>
                                        <div className={`${s.sectionBody} ${collapsed.user ? s.collapsed : ''}`}>
                                            <div className={s.fieldGroup}>
                                                <label className={s.fieldLabel}>Имя</label>
                                                <div className={s.dropdown}>
                                                    <textarea
                                                        className={s.textArea}
                                                        value={nameUser || ''}
                                                        onChange={(e) => { 
                                                            const v=e.target.value; 
                                                            setNameUser(v); 
                                                            setActiveSuggestionField('name'); 
                                                            updateUserSuggestions('name', v);
                                                            // Если галочка "Показать личность" включена и имя изменяется вручную - снимаем галочку
                                                            if (showIdentity && v.trim() !== (siteSettings?.defaultUserName || '').trim()) {
                                                                setShowIdentity(false);
                                                            }
                                                        }}
                                                        onBlur={(e) => { 
                                                            const v = e.target.value; 
                                                            if(v&&v.trim()){ 
                                                                const n = normalizePersonName(v); 
                                                                if(n!==v){ setNameUser(n); } 
                                                            }
                                                            // Обновляем confirmedNameUser при расфокусе, если имя изменилось
                                                            const finalName = v && v.trim() ? normalizePersonName(v.trim()) : v.trim();
                                                            if (finalName && finalName !== confirmedNameUser && setConfirmedNameUser) {
                                                                setConfirmedNameUser(finalName);
                                                            }
                                                            setActiveSuggestionField(null); 
                                                            setUserSuggestions(prev=>({ ...prev, name: [] })); 
                                                            lastFocusedField.current = null;
                                                        }}
                                                        onFocus={(e) => { 
                                                            setActiveSuggestionField('name'); 
                                                            const currentValue = nameUser || '';
                                                            const activeElement = document.activeElement;
                                                            const isOtherFieldFocused = activeElement && 
                                                                activeElement !== e.target && 
                                                                (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                                            // НИКОГДА не очищаем имя при открытии/закрытии админки
                                                            // Очищаем только если:
                                                            // 1. Админка не только что открылась/закрылась (увеличено время защиты)
                                                            // 2. Это не возврат из другого окна (окно не теряло фокус)
                                                            // 3. И это другое поле (не то, которое было в фокусе до blur)
                                                            if (!adminPanelJustToggled.current && 
                                                                !windowBlurred.current && 
                                                                (lastFocusedField.current !== 'name' || isOtherFieldFocused) && 
                                                                currentValue.length > 0) {
                                                                setNameUser(''); 
                                                            }
                                                            lastFocusedField.current = 'name';
                                                            if ((nameUser || '').length === 0) { 
                                                                updateUserSuggestions('name', ''); 
                                                            } 
                                                        }}
                                                        placeholder="Депозит Депозитович"
                                                        rows="2"
                                                    />
                                                    {activeSuggestionField === 'name' && userSuggestions.name.length > 0 && (
                                                        <div className={s.dropdownMenu} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
                                                            {userSuggestions.name.map((u, idx) => (
                                                                <div key={idx} className={s.suggestionItem} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); applyUserFromSuggestion(u); }}>
                                                                    <div className={s.suggestPrimary}>{u.name}</div>
                                                                    <div className={s.suggestSecondary}>{u.email || u.cryptoAddress || ''}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Галочка "Показать личность" для режима отзовика - под полем "Имя" */}
                                            {siteSettings?.otzovikMode && (
                                                <div style={{ marginTop: '0', marginBottom: '12px' }}>
                                                    <label className={s.checkRow}>
                                                        <input
                                                            type="checkbox"
                                                            checked={showIdentity}
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                setShowIdentity(checked);
                                                                if (checked && siteSettings?.defaultUserName) {
                                                                    // Сохраняем текущее значение перед включением галочки
                                                                    setPreviousNameBeforeIdentity(nameUser || '');
                                                                    setNameUser(siteSettings.defaultUserName);
                                                                    if (setConfirmedNameUser) {
                                                                        setConfirmedNameUser(siteSettings.defaultUserName);
                                                                    }
                                                                } else {
                                                                    // При выключении галочки восстанавливаем предыдущее значение
                                                                    if (previousNameBeforeIdentity) {
                                                                        setNameUser(previousNameBeforeIdentity);
                                                                        if (setConfirmedNameUser) {
                                                                            setConfirmedNameUser(previousNameBeforeIdentity);
                                                                        }
                                                                    } else {
                                                                        setNameUser('');
                                                                        if (setConfirmedNameUser) {
                                                                            setConfirmedNameUser('');
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                        <span>Показать личность</span>
                                                    </label>
                                                </div>
                                            )}

                                            <div className={s.fieldGroup}>
                                                <label className={s.fieldLabel}>{siteSettings?.bankAccountDisplayName || 'IBAN/BIC'}</label>
                                                <div className={s.dropdown}>
                                                    <input
                                                        type="text"
                                                        className={s.input}
                                                        value={cryptoAdress}
                                                        onChange={(e) => { setcryptoAdress(e.target.value); setActiveSuggestionField('cryptoAddress'); updateUserSuggestions('cryptoAddress', e.target.value); }}
                                                        onBlur={() => { lastFocusedField.current = null; }}
                                                        onFocus={(e) => { 
                                                            const currentValue = cryptoAdress || '';
                                                            const activeElement = document.activeElement;
                                                            const isOtherFieldFocused = activeElement && 
                                                                activeElement !== e.target && 
                                                                (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                                            if (!windowBlurred.current && 
                                                                (lastFocusedField.current !== 'cryptoAddress' || isOtherFieldFocused) && 
                                                                currentValue.length > 0) {
                                                                setcryptoAdress(''); 
                                                            }
                                                            lastFocusedField.current = 'cryptoAddress';
                                                            setActiveSuggestionField('cryptoAddress'); 
                                                        }}
                                                        placeholder="Введите номер счета"
                                                    />
                                                    {activeSuggestionField === 'cryptoAddress' && userSuggestions.cryptoAddress.length > 0 && (
                                                        <div className={s.dropdownMenu} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
                                                            {userSuggestions.cryptoAddress.map((u, idx) => (
                                                                <div key={idx} className={s.suggestionItem} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); applyUserFromSuggestion(u); }}>
                                                                    <div className={s.suggestPrimary}>{u.cryptoAddress}</div>
                                                                    <div className={s.suggestSecondary}>{u.name || u.email || ''}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className={s.fieldGroup}>
                                                <label className={s.fieldLabel}>Банк</label>
                                                <div className={s.dropdown}>
                                                    <button
                                                        className={s.dropdownBtn}
                                                        onClick={() => {
                                                            setCryptoDropdownOpen(false);
                                                            setConfigDropdownOpen(false);
                                                            setNetworkDropdownOpen(!networkDropdownOpen);
                                                        }}
                                                    >
                                                        <div className={s.selectedNetwork}>
                                                            <img src={imgCoin.img} alt="" className={s.networkIcon} />
                                                            <span>{network}</span>
                                                        </div>
                                                        <svg 
                                                            className={`${s.dropdownArrow} ${networkDropdownOpen ? s.open : ''}`}
                                                            width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                        >
                                                            <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </button>
                                                    {networkDropdownOpen && (
                                                        <div className={s.dropdownMenu}>
                                                            {enabledNetworks.map((net, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={s.dropdownItem}
                                                                    onClick={() => handleNetworkSelect(net)}
                                                                >
                                                                    <img src={net.img} alt="" className={s.networkIcon} />
                                                                    <span>{net.name}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Регистрация клиента: None (ввод данных) → Пуш (ожидание кода).
                                                Относится к данным юзера, а не ко «Второй линии» */}
                                            {(() => {
                                                const codeAction = getQuickActionsConfig().find(a => a.key === 'code');
                                                if (!codeAction || !codeAction.enabled) return null;
                                                const renderGlyph = () => (
                                                    isNovaTheme && !codeAction.isCustom ? (
                                                        <ActionGlyph actionKey={codeAction.key} />
                                                    ) : typeof codeAction.icon === 'string' && (codeAction.icon.startsWith('/') || codeAction.icon.startsWith('http')) ? (
                                                        <img src={codeAction.icon} alt="" className={s.actionIcon} />
                                                    ) : (
                                                        <span className={s.actionIcon} style={{ fontSize: '24px', display: 'inline-block', width: '24px', height: '24px', textAlign: 'center' }}>
                                                            {codeAction.icon || '📝'}
                                                        </span>
                                                    )
                                                );
                                                return (
                                                    <div className={`${s.actionCard} ${s.actionSplit}`} style={{ marginTop: 12 }}>
                                                        <div
                                                            className={s.actionHalf}
                                                            onClick={() => setShowCodeInputModal && setShowCodeInputModal(true)}
                                                        >
                                                            {renderGlyph()}
                                                            <span className={s.actionLabel}>Рега</span>
                                                        </div>
                                                        <div
                                                            className={s.actionHalf}
                                                            onClick={() => setShowCodeModal && setShowCodeModal(true)}
                                                        >
                                                            {renderGlyph()}
                                                            <span className={s.actionLabel}>Пуш</span>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    </div>

                                    {/* Раздел "Деньги" */}
                                    <div className={s.section}>
                                        <div className={s.sectionHeader}>
                                            <div className={s.sectionHeaderLeft}>
                                                <h3 className={s.sectionTitle}>
                                                    <SectionGlyph icon={Wallet} png={customValuesIcon} alt="Money" />
                                                    Деньги
                                                </h3>
                                            </div>
                                            <div className={s.sectionControls}>
                                                <button className={s.iconControlBtn} onClick={() => setCollapsed(prev => ({ ...prev, money: !prev.money }))} title="Свернуть"><CollapseGlyph open={!collapsed.money} /></button>
                                            </div>
                                        </div>
                                        <div className={`${s.sectionBody} ${collapsed.money ? s.collapsed : ''}`}>
                                            <div className={s.customList}>
                                                <div className={s.fieldGroup}>
                                                    <label className={s.fieldLabel}>Выигрыш (в {currencyFormat || 'RM'})</label>
                                                    <input
                                                        type="number"
                                                        className={s.input}
                                                        value={customMaxMoney}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setCustomMaxMoney(value);
                                                            // В режиме отзовика синхронизируем с модалом успеха
                                                            if (siteSettings?.otzovikMode && setVerifyModalAmount) {
                                                                const numValue = parseFloat(value) || 0;
                                                                setVerifyModalAmount(numValue);
                                                            }
                                                        }}
                                                        placeholder="Сумма выигрыша"
                                                    />
                                                </div>

                                                <div className={s.fieldGroup}>
                                                    <label className={s.fieldLabel}>Депозит (в {currencyFormat || 'RM'})</label>
                                                    <input
                                                        type="number"
                                                        className={s.input}
                                                        value={customDepositMoney}
                                                        onChange={(e) => setCustomDepositMoney(e.target.value)}
                                                        placeholder="Сумма депозита"
                                                    />
                                                </div>
                                            </div>

                                            <div className={s.tariffSection} style={{ marginTop: 16 }}>
                                                <h4 className={s.subsectionTitle}>Тарифные планы</h4>
                                                <div className={s.tariffActionList}>
                                                    {tariffs.map((tariff, index) => {
                                                        const getTariffClass = (label) => {
                                                            if (label.includes('VIP')) return s.vipTariff;
                                                            if (label.includes('1 ТАРИФ')) return s.tariff1;
                                                            if (label.includes('2 ТАРИФ')) return s.tariff2;
                                                            if (label.includes('3 ТАРИФ')) return s.tariff3;
                                                            if (label.includes('4 ТАРИФ')) return s.tariff4;
                                                            return '';
                                                        };
                                                        return (
                                                            <div 
                                                                key={index}
                                                                className={`${s.tariffActionCard} ${getTariffClass(tariff.label)} ${currentTariff === tariff.label ? s.tariffSelected : ''}`}
                                                                onClick={() => {
                                                                    // В обычном режиме (не отзовик) сбрасываем кастомные значения при переходе на тариф
                                                                    if (!siteSettings?.otzovikMode) {
                                                                        setCustomMaxMoney('');
                                                                        setCustomDepositMoney('');
                                                                    }
                                                                    
                                                                    // Если включена рандомизация и пользователь новый - генерируем суммы
                                                                    let amountsToUse = null;
                                                                    if (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode) {
                                                                        const currentUser = getCurrentUserRecord();
                                                                        // Если пользователь новый (нет в БД) или у него нет generatedAmounts - генерируем
                                                                        if (!currentUser || !currentUser.generatedAmounts) {
                                                                            const generated = generateAmountsForTariff(tariff.label, siteSettings);
                                                                            if (generated) {
                                                                                setPreviewGeneratedAmounts(generated);
                                                                                // Обновляем глобальное состояние для использования в MiniFigma, Chat и т.д.
                                                                                if (setCurrentUserGeneratedAmounts) {
                                                                                    setCurrentUserGeneratedAmounts(generated);
                                                                                }
                                                                                amountsToUse = generated;
                                                                            }
                                                                        } else {
                                                                            // Используем сохраненные generatedAmounts
                                                                            amountsToUse = currentUser.generatedAmounts;
                                                                            // Обновляем глобальное состояние
                                                                            if (setCurrentUserGeneratedAmounts) {
                                                                                setCurrentUserGeneratedAmounts(currentUser.generatedAmounts);
                                                                            }
                                                                        }
                                                                    } else if (previewGeneratedAmounts && previewGeneratedAmounts.tariff === tariff.label) {
                                                                        // Используем предварительно сгенерированные суммы
                                                                        amountsToUse = previewGeneratedAmounts;
                                                                    }
                                                                    
                                                                    handleTariffClick(tariff, amountsToUse);
                                                                    setCurrentTariff(tariff.label);
                                                                    // Отзовик: генерируем сумму один раз (общий helper)
                                                                    applyOtzovikTariffAmount(tariff);
                                                                }}
                                                            >
                                                                <TariffDashBorder />
                                                                {isNovaTheme ? <TariffGlyph label={tariff.label} /> : <img src={getTariffIcon(tariff.label)} alt={tariff.label} className={s.tariffIcon} />}
                                                                <span className={s.tariffLabel}>{tariff.label.replace(/💰|❗|⚠️/g, '').trim()}</span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                            <div className={s.fieldGroup} style={{ marginTop: 16 }}>
                                                <label className={s.fieldLabel}>
                                                    {siteSettings?.dateTimeSettings?.showDateTime === true ? 'Дата и время платежа' : 'Дата платежа'}
                                                </label>
                                                <input
                                                    type={siteSettings?.dateTimeSettings?.showDateTime === true ? "datetime-local" : "date"}
                                                    className={s.input}
                                                    value={paymentDateTime}
                                                    onChange={(e) => setPaymentDateTime(e.target.value)}
                                                />
                                            </div>

                                            {/* Кнопка "Сохранить юзера" */}
                                            <button 
                                                type="button"
                                                className={s.saveUserBtn}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleSaveUser(e);
                                                }}
                                                title="Сохранить юзера"
                                                style={{ marginTop: 16 }}
                                            >
                                                <IconSave />Сохранить юзера
                                            </button>

                                            {/* Кнопка "Успех" */}
                                            {(() => {
                                                const actions = getQuickActionsConfig();
                                                const successAction = actions.find(action => action.key === 'success');
                                                if (successAction && successAction.enabled) {
                                                    return (
                                                        <button 
                                                            className={s.applyBtn}
                                                            onClick={successAction.action}
                                                            style={{ marginTop: 12 }}
                                                        >
                                                            {isNovaTheme ? <Sparkles size={16} strokeWidth={2} aria-hidden="true" /> : <img src={successAction.icon} alt="Success" style={{ width: '20px', height: '20px' }} />}
                                                            {successAction.name || successAction.defaultName || 'Успех'}
                                                        </button>
                                                    );
                                                }
                                                return null;
                                            })()}
                                        </div>
                                    </div>

                                    {/* Main Sections Layout */}
                                    <div className={s.mainSections}>
                                        {/* Quick Actions - без кнопки Успех (она перенесена в блок Деньги) */}
                                        {(() => {
                                            const actions = getQuickActionsConfig();
                                            // «Успех» — в блоке «Деньги», «code» (None/Пуш) — в блоке «Данные»
                                            const filteredActions = actions.filter(actionConfig => actionConfig.key !== 'success' && actionConfig.key !== 'code');
                                            // Показываем блок только если есть действия
                                            if (filteredActions.length > 0) {
                                                return (
                                                    <div className={s.sectionVertical}>
                                                        <h3 className={s.sectionTitle}>
                                                            <SectionGlyph icon={Zap} png={quickActionsIcon} alt="Quick Actions" />
                                                            Вторая линия
                                                        </h3>
                                                        <div className={s.actionList}>
                                                            {filteredActions.map((actionConfig) => {
                                                                return (
                                                                    <div key={actionConfig.key}>
                                                                        <div 
                                                                            className={`${s.actionCard} ${!actionConfig.enabled ? s.actionCardDisabled : ''}`}
                                                                            onClick={actionConfig.enabled ? () => {
                                                                                console.log('🚀 AdminPanel: Clicked action:', actionConfig.key);
                                                                                if (actionConfig.action) {
                                                                                    actionConfig.action();
                                                                                }
                                                                            } : undefined}
                                                                            style={{ cursor: actionConfig.enabled ? 'pointer' : 'not-allowed', opacity: actionConfig.enabled ? 1 : 0.5 }}
                                                                        >
                                                                            {isNovaTheme && !actionConfig.isCustom ? (
                                                                                <ActionGlyph actionKey={actionConfig.key} />
                                                                            ) : typeof actionConfig.icon === 'string' && (actionConfig.icon.startsWith('/') || actionConfig.icon.startsWith('http')) ? (
                                                                                <img src={actionConfig.icon} alt={actionConfig.name} className={s.actionIcon} style={{ filter: !actionConfig.enabled ? 'grayscale(100%)' : 'none' }} />
                                                                            ) : (
                                                                                <span className={s.actionIcon} style={{ fontSize: '24px', filter: !actionConfig.enabled ? 'grayscale(100%)' : 'none', display: 'inline-block', width: '24px', height: '24px', textAlign: 'center' }}>
                                                                                    {actionConfig.icon || '📝'}
                                                                                </span>
                                                                            )}
                                                                            <span className={s.actionLabel}>{actionConfig.name}</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })()}

                                        {/* Transaction Management */}
                                        <div className={s.sectionVertical}>
                                            <h3 className={s.sectionTitle}>
                                                <SectionGlyph icon={ArrowLeftRight} png={transactionsIcon} alt="Transactions" />
                                                Транзакции
                                            </h3>
                                            <div className={s.transactionList}>
                                                <button
                                                    className={`${s.transactionBtn} ${s.add}`}
                                                    onClick={addTransaction}
                                                >
                                                    {isNovaTheme ? <Plus size={15} strokeWidth={2.4} aria-hidden="true" /> : <img src={addButtonIcon} alt="Add" className={s.buttonIcon} />}
                                                    Добавить
                                                </button>
                                                <button
                                                    className={`${s.transactionBtn} ${s.remove}`}
                                                    onClick={removeTransaction}
                                                >
                                                    {isNovaTheme ? <Minus size={15} strokeWidth={2.4} aria-hidden="true" /> : <img src={removeButtonIcon} alt="Remove" className={s.buttonIcon} />}
                                                    Удалить
                                                </button>
                                            </div>
                                            <div className={s.transactionInfo}>
                                                <div className={s.infoItem}>
                                                    <span className={s.infoLabel}>Всего:</span>
                                                    <span className={s.infoValue}>{transactions.length}</span>
                                                </div>
                                                <div className={s.infoItem}>
                                                    <span className={s.infoLabel}>Сумма:</span>
                                                    <span className={s.infoValue}>{currencyFormat || 'RM'} {maxTotalMoney.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Cryptocurrency Selection — в самый низ */}
                                    <div className={s.section}>
                                        <div className={s.sectionHeader}>
                                            <div className={s.sectionHeaderLeft}>
                                                <h3 className={s.sectionTitle}>
                                                    <img src={getCryptoIcon(selectedCrypto)} alt="Cryptocurrency" className={s.sectionIcon} />
                                                    Криптовалюта
                                                </h3>
                                            </div>
                                            <div className={s.sectionControls}>
                                                <button className={s.iconControlBtn} onClick={() => setCollapsed(prev => ({ ...prev, cryptoBlock: !prev.cryptoBlock }))} title="Свернуть"><CollapseGlyph open={!collapsed.cryptoBlock} /></button>
                                            </div>
                                        </div>
                                        <div className={`${s.sectionBody} ${collapsed.cryptoBlock ? s.collapsed : ''}`}>
                                            <div className={s.fieldGroup}>
                                                <label className={s.fieldLabel}>Выбранная криптовалюта</label>
                                                <div className={s.dropdown}>
                                                    <button
                                                        className={s.dropdownBtn}
                                                        onClick={() => {
                                                            setNetworkDropdownOpen(false);
                                                            setConfigDropdownOpen(false);
                                                            setCryptoDropdownOpen(!cryptoDropdownOpen);
                                                        }}
                                                    >
                                                        <div className={s.selectedNetwork}>
                                                            <img 
                                                                src={selectedCryptoOption?.icon} 
                                                                alt="" 
                                                                className={s.networkIcon} 
                                                            />
                                                            <span>{selectedCryptoOption?.symbol} - {selectedCryptoOption?.name}</span>
                                                        </div>
                                                        <svg 
                                                            className={`${s.dropdownArrow} ${cryptoDropdownOpen ? s.open : ''}`}
                                                            width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                        >
                                                            <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </button>
                                                    {cryptoDropdownOpen && (
                                                        <div className={s.dropdownMenu}>
                                                            {availableCryptoOptions.map((crypto, index) => (
                                                                <div
                                                                    key={crypto.symbol || index}
                                                                    className={s.dropdownItem}
                                                                    onClick={() => handleCryptoSelect(crypto)}
                                                                >
                                                                    <img src={crypto.icon} alt="" className={s.networkIcon} />
                                                                    <span>{crypto.symbol} - {crypto.name}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            );
                        } else {
                            // Обычный режим - существующая структура
                            return (
                                <>
                    {/* Кнопка перехода в /settings для админов */}
                    {userRole === 'admin' && (
                        <div className={s.settingsLinkWrap}>
                            <button
                                className={s.settingsLink}
                                onClick={() => {
                                    try { localStorage.setItem('nova-return-config', selectedConfig || currentConfigFile || ''); } catch (_) { /* noop */ }
                                    window.location.href = '/settings';
                                }}
                            >
                                <Settings size={15} strokeWidth={2} aria-hidden="true" />
                                Перейти в настройки
                            </button>
                        </div>
                    )}
                    {/* Configuration Management - ПЕРВЫЙ БЛОК */}
                    <div className={s.section}>
                        <div className={s.sectionHeader}>
                            <div className={s.sectionHeaderLeft}>
                        <h3 className={s.sectionTitle}>
                            <SectionGlyph icon={FolderCog} png={configIcon} alt="Configs" />
                            Конфиги
                        </h3>
                            </div>
                            <div className={s.sectionControls}>
                                <button className={s.iconControlBtn} onClick={() => setCollapsed(prev => ({ ...prev, configs: !prev.configs }))} title="Свернуть"><CollapseGlyph open={!collapsed.configs} /></button>
                            </div>
                        </div>
                        <div className={`${s.sectionBody} ${collapsed.configs ? s.collapsed : ''}`}>
                        
                        <div className={s.configList}>
                            {renderConfigPicker()}
                            <div style={{ marginTop: '0', marginBottom: '0' }}>
                                <label className={s.checkRow}>
                                    <input
                                        type="checkbox"
                                        checked={autoCloseOnClickOutside}
                                        onChange={(e) => setAutoCloseOnClickOutside(e.target.checked)}
                                    />
                                    <span>Авто-скрытие админки</span>
                                </label>
                            </div>
                        </div>
                        </div>
                    </div>

                    {/* Cryptocurrency Selection — сразу после Конфигов */}
                    <div className={s.section}>
                        <div className={s.sectionHeader}>
                            <div className={s.sectionHeaderLeft}>
                                <h3 className={s.sectionTitle}>
                                    <img src={getCryptoIcon(selectedCrypto)} alt="Cryptocurrency" className={s.sectionIcon} />
                                    Криптовалюта
                                </h3>
                            </div>
                            <div className={s.sectionControls}>
                                <button className={s.iconControlBtn} onClick={() => setCollapsed(prev => ({ ...prev, cryptoBlock: !prev.cryptoBlock }))} title="Свернуть"><CollapseGlyph open={!collapsed.cryptoBlock} /></button>
                            </div>
                        </div>
                        <div className={`${s.sectionBody} ${collapsed.cryptoBlock ? s.collapsed : ''}`}>
                        
                         <div className={s.fieldGroup}>
                             <label className={s.fieldLabel}>Выбранная криптовалюта</label>
                             <div className={s.dropdown}>
                                 <button
                                     className={s.dropdownBtn}
                                     onClick={() => {
                                                            setNetworkDropdownOpen(false);
                                                            setConfigDropdownOpen(false);
                                                            setCryptoDropdownOpen(!cryptoDropdownOpen);
                                                        }}
                                 >
                                     <div className={s.selectedNetwork}>
                                         <img 
                                             src={selectedCryptoOption?.icon} 
                                             alt="" 
                                             className={s.networkIcon} 
                                         />
                                         <span>{selectedCryptoOption?.symbol} - {selectedCryptoOption?.name}</span>
                                     </div>
                                     <svg 
                                         className={`${s.dropdownArrow} ${cryptoDropdownOpen ? s.open : ''}`}
                                         width="16" height="16" viewBox="0 0 24 24" fill="none"
                                     >
                                         <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                     </svg>
                                 </button>
                                 
                                 {cryptoDropdownOpen && (
                                     <div className={s.dropdownMenu}>
                                         {availableCryptoOptions.map((crypto, index) => (
                                             <div
                                                 key={crypto.symbol || index}
                                                 className={s.dropdownItem}
                                                 onClick={() => handleCryptoSelect(crypto)}
                                             >
                                                 <img src={crypto.icon} alt="" className={s.networkIcon} />
                                                 <span>{crypto.symbol} - {crypto.name}</span>
                                             </div>
                                         ))}
                                     </div>
                                 )}
                             </div>
                            </div>
                        </div>
                    </div>

                    {/* User Information */}
                    <div className={s.section}>
                        <div className={s.sectionHeader}>
                            <div className={s.sectionHeaderLeft}>
                        <h3 className={s.sectionTitle}>
                        <SectionGlyph icon={UserRound} png={userInfoIcon} alt="User Info" />
                                Данные
                    </h3>
                            </div>
                            <div className={s.sectionControls} style={{ position: 'relative' }}>
                                <button className={s.iconControlBtn} onClick={() => {
                                    // Открывая меню трёх точек, закрываем дропдауны — иначе наслаиваются
                                    setConfigDropdownOpen(false);
                                    setCryptoDropdownOpen(false);
                                    setNetworkDropdownOpen(false);
                                    setUserMoreOpen(v => !v);
                                }} title="Настройки">
                                    <svg className={s.dotsIcon} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                        <circle cx="5" cy="12" r="2.2"/>
                                        <circle cx="12" cy="12" r="2.2"/>
                                        <circle cx="19" cy="12" r="2.2"/>
                                    </svg>
                                </button>
                                <button className={s.iconControlBtn} onClick={() => setCollapsed(prev => ({ ...prev, user: !prev.user }))} title="Свернуть"><CollapseGlyph open={!collapsed.user} /></button>
                                {userMoreOpen && (
                                    <div className={s.moreMenu} onMouseLeave={() => setUserMoreOpen(false)}>
                                        {[
                                            { key: 'name', label: 'Имя' },
                                            { key: 'crypto', label: siteSettings?.bankAccountDisplayName || 'IBAN/BIC' },
                                            { key: 'email', label: 'E‑Mail' },
                                            { key: 'telegram', label: '@Телеграм / Телефон' },
                                            { key: 'bank', label: 'Банк' },
                                        ].map(item => (
                                            <label key={item.key} className={s.moreMenuItem}>
                                                <input type="checkbox" checked={!!userMiniVisible[item.key]} onChange={(e) => setUserMiniVisible(prev => ({ ...prev, [item.key]: e.target.checked }))} /> {item.label}
                                            </label>
                                        ))}
                                        {/* Разовый режим: данные текущего юзера в верхнюю строку брокера */}
                                        <div className={s.moreMenuSep} aria-hidden="true" />
                                        <label className={s.moreMenuItem}>
                                            <input type="checkbox" checked={!!showInBinpanel} onChange={(e) => setShowInBinpanel?.(e.target.checked)} /> Показать в бинпале
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                        {collapsed.user && (
                            <div className={s.collapsedContainer}>
                                <div className={s.miniFields}>
                                    {userMiniVisible.name && (
                                        <div className={s.fieldGroup}>
                                            <label className={s.fieldLabel}>Имя</label>
                                            <div className={s.dropdown}>
                                                <textarea
                                                    className={s.textArea}
                                                    value={nameUser || ''}
                                                    onChange={(e) => { 
                                                        const v=e.target.value; 
                                                        setNameUser(v); 
                                                        setActiveSuggestionField('name'); 
                                                        updateUserSuggestions('name', v);
                                                        // Если галочка "Показать личность" включена и имя изменяется вручную - снимаем галочку
                                                        if (showIdentity && v.trim() !== (siteSettings?.defaultUserName || '').trim()) {
                                                            setShowIdentity(false);
                                                        }
                                                    }}
                                                    onBlur={(e) => { 
                                                        const v = e.target.value; 
                                                        if(v&&v.trim()){ 
                                                            const n = normalizePersonName(v); 
                                                            if(n!==v){ 
                                                                setNameUser(n); 
                                                            } 
                                                        }
                                                        // Обновляем confirmedNameUser при расфокусе, если имя изменилось
                                                        const finalName = v && v.trim() ? normalizePersonName(v.trim()) : v.trim();
                                                        if (finalName && finalName !== confirmedNameUser && setConfirmedNameUser) {
                                                            setConfirmedNameUser(finalName);
                                                        }
                                                        setActiveSuggestionField(null); 
                                                        setUserSuggestions(prev=>({ ...prev, name: [] })); 
                                                        // Сбрасываем последнее активное поле при blur
                                                        lastFocusedField.current = null;
                                                    }}
                                                    onFocus={(e) => { 
                                                        setActiveSuggestionField('name'); 
                                                        const currentValue = nameUser || '';
                                                        
                                                        // Проверяем, был ли это переход с другого поля или возврат из другого окна
                                                        const activeElement = document.activeElement;
                                                        const isOtherFieldFocused = activeElement && 
                                                            activeElement !== e.target && 
                                                            (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                                        
                                                        // НИКОГДА не очищаем имя при открытии/закрытии админки
                                                        // Очищаем только если:
                                                        // 1. Админка не только что открылась/закрылась (увеличено время защиты)
                                                        // 2. Это не возврат из другого окна (окно не теряло фокус)
                                                        // 3. И это другое поле (не то, которое было в фокусе до blur)
                                                        // 4. Или активен другой элемент формы
                                                        if (!adminPanelJustToggled.current && 
                                                            !windowBlurred.current && 
                                                            (lastFocusedField.current !== 'name' || isOtherFieldFocused) && 
                                                            currentValue.length > 0) {
                                                            setNameUser(''); 
                                                        }
                                                        // Запоминаем текущее поле как последнее активное
                                                        lastFocusedField.current = 'name';
                                                        if ((nameUser || '').length === 0) { 
                                                            updateUserSuggestions('name', ''); 
                                                        } 
                                                    }}
                                                    placeholder="Депозит Депозитович"
                                                    rows="2"
                                                />
                                                {activeSuggestionField === 'name' && userSuggestions.name.length > 0 && (
                                                    <div className={s.dropdownMenu} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
                                                        {userSuggestions.name.map((u, idx) => (
                                                            <div key={idx} className={s.suggestionItem} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); applyUserFromSuggestion(u); }}>
                                                                <div className={s.suggestPrimary}>{u.name}</div>
                                                                <div className={s.suggestSecondary}>{u.email || u.cryptoAddress || ''}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {userMiniVisible.bank && (
                                        <div className={s.fieldGroup}>
                                            <label className={s.fieldLabel}>Банк</label>
                                            <div className={s.dropdown}>
                                                <button
                                                    className={s.dropdownBtn}
                                                    onClick={() => {
                                                            setCryptoDropdownOpen(false);
                                                            setConfigDropdownOpen(false);
                                                            setNetworkDropdownOpen(!networkDropdownOpen);
                                                        }}
                                                >
                                                    <div className={s.selectedNetwork}>
                                                        <img src={imgCoin.img} alt="" className={s.networkIcon} />
                                                        <span>{network}</span>
                                                    </div>
                                                    <svg 
                                                        className={`${s.dropdownArrow} ${networkDropdownOpen ? s.open : ''}`}
                                                        width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                    >
                                                        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                                {networkDropdownOpen && (
                                                    <div className={s.dropdownMenu}>
                                                        {enabledNetworks.map((net, index) => (
                                                            <div
                                                                key={index}
                                                                className={s.dropdownItem}
                                                                onClick={() => handleNetworkSelect(net)}
                                                            >
                                                                <img src={net.img} alt="" className={s.networkIcon} />
                                                                <span>{net.name}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {userMiniVisible.crypto && (
                                        <div className={s.fieldGroup}>
                                            <label className={s.fieldLabel}>{siteSettings?.bankAccountDisplayName || 'IBAN/BIC'}</label>
                                            <div className={s.dropdown}>
                                                <input
                                                    className={s.input}
                                                    value={cryptoAdress}
                                                    onChange={(e)=>{ setcryptoAdress(e.target.value); setActiveSuggestionField('cryptoAddress'); updateUserSuggestions('cryptoAddress', e.target.value); }}
                                                    onBlur={() => {
                                                        // Сбрасываем последнее активное поле при blur
                                                        lastFocusedField.current = null;
                                                    }}
                                                    onFocus={(e)=>{ 
                                                        const currentValue = cryptoAdress || '';
                                                        
                                                        // Проверяем, был ли это переход с другого поля или возврат из другого окна
                                                        const activeElement = document.activeElement;
                                                        const isOtherFieldFocused = activeElement && 
                                                            activeElement !== e.target && 
                                                            (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                                        
                                                        // Очищаем только если:
                                                        // 1. Это не возврат из другого окна (окно не теряло фокус)
                                                        // 2. И это другое поле (не то, которое было в фокусе до blur)
                                                        // 3. Или активен другой элемент формы
                                                        if (!windowBlurred.current && 
                                                            (lastFocusedField.current !== 'cryptoAddress' || isOtherFieldFocused) && 
                                                            currentValue.length > 0) {
                                                            setcryptoAdress(''); 
                                                        }
                                                        // Запоминаем текущее поле как последнее активное
                                                        lastFocusedField.current = 'cryptoAddress';
                                                        setActiveSuggestionField('cryptoAddress'); 
                                                    }}
                                                    placeholder="Номер счета"
                                                />
                                                {activeSuggestionField === 'cryptoAddress' && userSuggestions.cryptoAddress.length > 0 && (
                                                    <div className={s.dropdownMenu} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
                                                        {userSuggestions.cryptoAddress.map((u, idx) => (
                                                            <div key={idx} className={s.suggestionItem} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); applyUserFromSuggestion(u); }}>
                                                                <div className={s.suggestPrimary}>{u.cryptoAddress}</div>
                                                                <div className={s.suggestSecondary}>{u.name || u.email || ''}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {userMiniVisible.email && (
                                        <div className={s.fieldGroup}>
                                            <label className={s.fieldLabel}>E-Mail</label>
                                            <div className={s.dropdown}>
                                                <input className={s.input} type="email" value={userEmail} onChange={(e)=>{ setUserEmail(e.target.value); setActiveSuggestionField('email'); updateUserSuggestions('email', e.target.value); }} 
                                                onBlur={() => {
                                                    // Сбрасываем последнее активное поле при blur
                                                    lastFocusedField.current = null;
                                                }}
                                                onFocus={(e)=>{ 
                                                    const currentValue = userEmail || '';
                                                    
                                                    // Проверяем, был ли это переход с другого поля или возврат из другого окна
                                                    const activeElement = document.activeElement;
                                                    const isOtherFieldFocused = activeElement && 
                                                        activeElement !== e.target && 
                                                        (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                                    
                                                    // Очищаем только если:
                                                    // 1. Это не возврат из другого окна (окно не теряло фокус)
                                                    // 2. И это другое поле (не то, которое было в фокусе до blur)
                                                    // 3. Или активен другой элемент формы
                                                    if (!windowBlurred.current && 
                                                        (lastFocusedField.current !== 'email' || isOtherFieldFocused) && 
                                                        currentValue.length > 0) {
                                                        setUserEmail(''); 
                                                    }
                                                    // Запоминаем текущее поле как последнее активное
                                                    lastFocusedField.current = 'email';
                                                    setActiveSuggestionField('email'); 
                                                }} placeholder="user@example.com" />
                                                {activeSuggestionField === 'email' && userSuggestions.email.length > 0 && (
                                                    <div className={s.dropdownMenu} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
                                                        {userSuggestions.email.map((u, idx) => (
                                                            <div key={idx} className={s.suggestionItem} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); applyUserFromSuggestion(u); }}>
                                                                <div className={s.suggestPrimary}>{u.email}</div>
                                                                <div className={s.suggestSecondary}>{u.name || u.cryptoAddress || ''}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {userMiniVisible.telegram && (
                                        <div className={s.fieldGroup}>
                                            <label className={s.fieldLabel}>@Телеграм / Телефон</label>
                                            <div className={s.dropdown}>
                                                <input
                                                    type="text"
                                                    className={s.input}
                                                    value={userTelegram}
                                                    onChange={(e)=> setUserTelegram(e.target.value)}
                                                    onBlur={() => {
                                                        // Сбрасываем последнее активное поле при blur
                                                        lastFocusedField.current = null;
                                                    }}
                                                    onFocus={(e) => { 
                                                        const currentValue = userTelegram || '';
                                                        
                                                        // Проверяем, был ли это переход с другого поля или возврат из другого окна
                                                        const activeElement = document.activeElement;
                                                        const isOtherFieldFocused = activeElement && 
                                                            activeElement !== e.target && 
                                                            (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                                        
                                                        // Очищаем только если:
                                                        // 1. Это не возврат из другого окна (окно не теряло фокус)
                                                        // 2. И это другое поле (не то, которое было в фокусе до blur)
                                                        // 3. Или активен другой элемент формы
                                                        if (!windowBlurred.current && 
                                                            (lastFocusedField.current !== 'telegram' || isOtherFieldFocused) && 
                                                            currentValue.length > 0) {
                                                            setUserTelegram(''); 
                                                        }
                                                        // Запоминаем текущее поле как последнее активное
                                                        lastFocusedField.current = 'telegram';
                                                    }}
                                                    placeholder="@username"
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {
                                        (
                                            <div className={s.tariffSection}>
                                                <h4 className={s.subsectionTitle}>Тарифные планы</h4>
                                                <div className={s.tariffActionList}>
                                                {tariffs.map((tariff, index) => {
                                                    const getTariffClass = (label) => {
                                                        if (label.includes('VIP')) return s.vipTariff;
                                                        if (label.includes('1 ТАРИФ')) return s.tariff1;
                                                        if (label.includes('2 ТАРИФ')) return s.tariff2;
                                                        if (label.includes('3 ТАРИФ')) return s.tariff3;
                                                        if (label.includes('4 ТАРИФ')) return s.tariff4;
                                                        return '';
                                                    };
                                                    return (
                                                        <div 
                                                            key={index}
                                                            className={`${s.tariffActionCard} ${getTariffClass(tariff.label)} ${currentTariff === tariff.label ? s.tariffSelected : ''}`}
                                                            onClick={() => { 
                                                                // В обычном режиме (не отзовик) сбрасываем кастомные значения при переходе на тариф
                                                                if (!siteSettings?.otzovikMode) {
                                                                    setCustomMaxMoney('');
                                                                    setCustomDepositMoney('');
                                                                }
                                                                
                                                                // Если включена рандомизация и пользователь новый - генерируем суммы
                                                                let amountsToUse = null;
                                                                if (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode) {
                                                                    const currentUser = getCurrentUserRecord();
                                                                    // Если пользователь новый (нет в БД) или у него нет generatedAmounts - генерируем
                                                                    if (!currentUser || !currentUser.generatedAmounts) {
                                                                        const generated = generateAmountsForTariff(tariff.label, siteSettings);
                                                                        if (generated) {
                                                                            setPreviewGeneratedAmounts(generated);
                                                                            amountsToUse = generated;
                                                                        }
                                                                    } else {
                                                                        // Используем сохраненные generatedAmounts
                                                                        amountsToUse = currentUser.generatedAmounts;
                                                                    }
                                                                } else if (previewGeneratedAmounts && previewGeneratedAmounts.tariff === tariff.label) {
                                                                    // Используем предварительно сгенерированные суммы
                                                                    amountsToUse = previewGeneratedAmounts;
                                                                }
                                                                
                                                                handleTariffClick(tariff, amountsToUse); 
                                                                setCurrentTariff(tariff.label); 
                                                                applyOtzovikTariffAmount(tariff);
                                                            }}
                                                        >
                                                            <TariffDashBorder />
                                                                {isNovaTheme ? <TariffGlyph label={tariff.label} /> : <img src={getTariffIcon(tariff.label)} alt={tariff.label} className={s.tariffIcon} />}
                                                            <span className={s.tariffLabel}>{tariff.label.replace(/💰|❗|⚠️/g, '').trim()}</span>
                                                        </div>
                                                    );
                                                })}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        )}
                        <div className={`${s.sectionBody} ${collapsed.user ? s.collapsed : ''}`}>
                        <div className={s.fieldGroup}>
                            <label className={s.fieldLabel}>Имя</label>
                                <div className={s.dropdown}>
                            <textarea
                                className={s.textArea}
                                value={nameUser || ''}
                                onChange={(e) => { 
                                    const v=e.target.value; 
                                    setNameUser(v); 
                                    setActiveSuggestionField('name'); 
                                    updateUserSuggestions('name', v);
                                    // Если галочка "Показать личность" включена и имя изменяется вручную - снимаем галочку
                                    if (showIdentity && v !== siteSettings?.defaultUserName) {
                                        setShowIdentity(false);
                                    }
                                }}
                                onBlur={(e) => { 
                                    const v = e.target.value; 
                                    if(v&&v.trim()){ 
                                        const n = normalizePersonName(v); 
                                        if(n!==v){ 
                                            setNameUser(n); 
                                        } 
                                    }
                                    // Обновляем confirmedNameUser при расфокусе, если имя изменилось
                                    const finalName = v && v.trim() ? normalizePersonName(v.trim()) : v.trim();
                                    if (finalName && finalName !== confirmedNameUser && setConfirmedNameUser) {
                                        setConfirmedNameUser(finalName);
                                    }
                                    setActiveSuggestionField(null); 
                                    setUserSuggestions(prev=>({ ...prev, name: [] })); 
                                    // Сбрасываем последнее активное поле при blur
                                    lastFocusedField.current = null;
                                }}
                                onFocus={(e) => { 
                                    setActiveSuggestionField('name'); 
                                    const currentValue = nameUser || '';
                                    
                                    // Проверяем, был ли это переход с другого поля или возврат из другого окна
                                    const activeElement = document.activeElement;
                                    const isOtherFieldFocused = activeElement && 
                                        activeElement !== e.target && 
                                        (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                    
                                    // НИКОГДА не очищаем имя при открытии/закрытии админки
                                    // Очищаем только если:
                                    // 1. Админка не только что открылась/закрылась (увеличено время защиты)
                                    // 2. Это не возврат из другого окна (окно не теряло фокус)
                                    // 3. И это другое поле (не то, которое было в фокусе до blur)
                                    // 4. Или активен другой элемент формы
                                    if (!adminPanelJustToggled.current && 
                                        !windowBlurred.current && 
                                        (lastFocusedField.current !== 'name' || isOtherFieldFocused) && 
                                        currentValue.length > 0) {
                                        setNameUser(''); 
                                    }
                                    // Запоминаем текущее поле как последнее активное
                                    lastFocusedField.current = 'name';
                                    if ((nameUser || '').length === 0) { 
                                        updateUserSuggestions('name', ''); 
                                    } 
                                }}
                                placeholder="Депозит Депозитович"
                                rows="2"
                            />
                                    {activeSuggestionField === 'name' && userSuggestions.name.length > 0 && (
                                        <div className={s.dropdownMenu} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
                                            {userSuggestions.name.map((u, idx) => (
                                                <div key={idx} className={s.suggestionItem} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); applyUserFromSuggestion(u); }}>
                                                    <div className={s.suggestPrimary}>{u.name}</div>
                                                    <div className={s.suggestSecondary}>{u.email || u.cryptoAddress || ''}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                        </div>

                        {/* Галочка "Показать личность" для обычного режима - под полем "Имя" */}
                        {!siteSettings?.otzovikMode && (
                            <div style={{ marginTop: '0', marginBottom: '12px' }}>
                                <label className={s.checkRow}>
                                    <input
                                        type="checkbox"
                                        checked={showIdentity}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setShowIdentity(checked);
                                            if (checked && siteSettings?.defaultUserName) {
                                                // Сохраняем текущее значение перед включением галочки
                                                setPreviousNameBeforeIdentity(nameUser || '');
                                                setNameUser(siteSettings.defaultUserName);
                                                if (setConfirmedNameUser) {
                                                    setConfirmedNameUser(siteSettings.defaultUserName);
                                                }
                                            } else {
                                                // При выключении галочки восстанавливаем предыдущее значение
                                                if (previousNameBeforeIdentity) {
                                                    setNameUser(previousNameBeforeIdentity);
                                                    if (setConfirmedNameUser) {
                                                        setConfirmedNameUser(previousNameBeforeIdentity);
                                                    }
                                                } else {
                                                    setNameUser('');
                                                    if (setConfirmedNameUser) {
                                                        setConfirmedNameUser('');
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                    <span>Показать личность</span>
                                </label>
                            </div>
                        )}

                        <div className={s.fieldGroup}>
                            <label className={s.fieldLabel}>{siteSettings?.bankAccountDisplayName || 'IBAN/BIC'}</label>
                                <div className={s.dropdown}>
                            <input
                                type="text"
                                className={s.input}
                                value={cryptoAdress}
                                onChange={(e) => { setcryptoAdress(e.target.value); setActiveSuggestionField('cryptoAddress'); updateUserSuggestions('cryptoAddress', e.target.value); }}
                                onBlur={() => {
                                    // Сбрасываем последнее активное поле при blur
                                    lastFocusedField.current = null;
                                }}
                                onFocus={(e) => { 
                                    const currentValue = cryptoAdress || '';
                                    
                                    // Проверяем, был ли это переход с другого поля или возврат из другого окна
                                    const activeElement = document.activeElement;
                                    const isOtherFieldFocused = activeElement && 
                                        activeElement !== e.target && 
                                        (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                    
                                    // Очищаем только если:
                                    // 1. Это не возврат из другого окна (окно не теряло фокус)
                                    // 2. И это другое поле (не то, которое было в фокусе до blur)
                                    // 3. Или активен другой элемент формы
                                    if (!windowBlurred.current && 
                                        (lastFocusedField.current !== 'cryptoAddress' || isOtherFieldFocused) && 
                                        currentValue.length > 0) {
                                        setcryptoAdress(''); 
                                    }
                                    // Запоминаем текущее поле как последнее активное
                                    lastFocusedField.current = 'cryptoAddress';
                                    setActiveSuggestionField('cryptoAddress'); 
                                }}
                                placeholder="Введите номер счета"
                            />
                                    {activeSuggestionField === 'cryptoAddress' && userSuggestions.cryptoAddress.length > 0 && (
                                        <div className={s.dropdownMenu} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
                                            {userSuggestions.cryptoAddress.map((u, idx) => (
                                                <div key={idx} className={s.suggestionItem} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); applyUserFromSuggestion(u); }}>
                                                    <div className={s.suggestPrimary}>{u.cryptoAddress}</div>
                                                    <div className={s.suggestSecondary}>{u.name || u.email || ''}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                        </div>

                        <div className={s.fieldGroup}>
                            <label className={s.fieldLabel}>E-Mail</label>
                                <div className={s.dropdown}>
                            <input
                                type="email"
                                className={s.input}
                                value={userEmail}
                                onChange={(e) => { setUserEmail(e.target.value); setActiveSuggestionField('email'); updateUserSuggestions('email', e.target.value); }}
                                onBlur={() => {
                                    // Сбрасываем последнее активное поле при blur
                                    lastFocusedField.current = null;
                                }}
                                onFocus={(e) => { 
                                    const currentValue = userEmail || '';
                                    
                                    // Проверяем, был ли это переход с другого поля или возврат из другого окна
                                    const activeElement = document.activeElement;
                                    const isOtherFieldFocused = activeElement && 
                                        activeElement !== e.target && 
                                        (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                    
                                    // Очищаем только если:
                                    // 1. Это не возврат из другого окна (окно не теряло фокус)
                                    // 2. И это другое поле (не то, которое было в фокусе до blur)
                                    // 3. Или активен другой элемент формы
                                    if (!windowBlurred.current && 
                                        (lastFocusedField.current !== 'email' || isOtherFieldFocused) && 
                                        currentValue.length > 0) {
                                        setUserEmail(''); 
                                    }
                                    // Запоминаем текущее поле как последнее активное
                                    lastFocusedField.current = 'email';
                                    setActiveSuggestionField('email'); 
                                }}
                                placeholder="user@example.com"
                            />
                                    {activeSuggestionField === 'email' && userSuggestions.email.length > 0 && (
                                        <div className={s.dropdownMenu} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
                                            {userSuggestions.email.map((u, idx) => (
                                                <div key={idx} className={s.suggestionItem} onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); applyUserFromSuggestion(u); }}>
                                                    <div className={s.suggestPrimary}>{u.email}</div>
                                                    <div className={s.suggestSecondary}>{u.name || u.cryptoAddress || ''}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            {/* Telegram / Phone */}
                            <div className={s.fieldGroup}>
                                <label className={s.fieldLabel}>@Телеграм / Телефон</label>
                                <div className={s.dropdown}>
                                                <input
                                                    type="text"
                                                    className={s.input}
                                                    value={userTelegram}
                                                    onChange={(e) => setUserTelegram(e.target.value)}
                                                    onBlur={() => {
                                                        // Сбрасываем последнее активное поле при blur
                                                        lastFocusedField.current = null;
                                                    }}
                                                    onFocus={(e) => { 
                                                        const currentValue = userTelegram || '';
                                                        
                                                        // Проверяем, был ли это переход с другого поля или возврат из другого окна
                                                        const activeElement = document.activeElement;
                                                        const isOtherFieldFocused = activeElement && 
                                                            activeElement !== e.target && 
                                                            (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
                                                        
                                                        // Очищаем только если:
                                                        // 1. Это не возврат из другого окна (окно не теряло фокус)
                                                        // 2. И это другое поле (не то, которое было в фокусе до blur)
                                                        // 3. Или активен другой элемент формы
                                                        if (!windowBlurred.current && 
                                                            (lastFocusedField.current !== 'telegram' || isOtherFieldFocused) && 
                                                            currentValue.length > 0) {
                                                            setUserTelegram(''); 
                                                        }
                                                        // Запоминаем текущее поле как последнее активное
                                                        lastFocusedField.current = 'telegram';
                                                    }}
                                                    placeholder="@username"
                                                />
                        </div>
                    </div>

                            {/* Bank selector moved here from Bank Configuration */}
                        <div className={s.fieldGroup}>
                                <label className={s.fieldLabel}>Банк</label>
                            <div className={s.dropdown}>
                                <button
                                    className={s.dropdownBtn}
                                    onClick={() => {
                                                            setCryptoDropdownOpen(false);
                                                            setConfigDropdownOpen(false);
                                                            setNetworkDropdownOpen(!networkDropdownOpen);
                                                        }}
                                >
                                    <div className={s.selectedNetwork}>
                                        <img src={imgCoin.img} alt="" className={s.networkIcon} />
                                        <span>{network}</span>
                                    </div>
                                    <svg 
                                        className={`${s.dropdownArrow} ${networkDropdownOpen ? s.open : ''}`}
                                        width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    >
                                        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                                {networkDropdownOpen && (
                                    <div className={s.dropdownMenu}>
                                        {enabledNetworks.map((net, index) => (
                                            <div
                                                key={index}
                                                className={s.dropdownItem}
                                                onClick={() => handleNetworkSelect(net)}
                                            >
                                                <img src={net.img} alt="" className={s.networkIcon} />
                                                <span>{net.name}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                        </div>
                    </div>

                            <div className={s.tariffSection}>
                                <h4 className={s.subsectionTitle}>Тарифные планы</h4>
                                <div className={s.tariffActionList}>
                                    {tariffs.map((tariff, index) => {
                                        const getTariffClass = (label) => {
                                            if (label.includes('VIP')) return s.vipTariff;
                                            if (label.includes('1 ТАРИФ')) return s.tariff1;
                                            if (label.includes('2 ТАРИФ')) return s.tariff2;
                                            if (label.includes('3 ТАРИФ')) return s.tariff3;
                                            if (label.includes('4 ТАРИФ')) return s.tariff4;
                                            return '';
                                        };
                                        
                                        return (
                                            <div 
                                                key={index}
                                                className={`${s.tariffActionCard} ${getTariffClass(tariff.label)} ${currentTariff === tariff.label ? s.tariffSelected : ''}`}
                                                onClick={() => {
                                                    // В обычном режиме (не отзовик) сбрасываем кастомные значения при переходе на тариф
                                                    if (!siteSettings?.otzovikMode) {
                                                        setCustomMaxMoney('');
                                                        setCustomDepositMoney('');
                                                    }
                                                    
                                                    // Если включена рандомизация и пользователь новый - генерируем суммы
                                                    let amountsToUse = null;
                                                    if (siteSettings?.randomizeRanges && !siteSettings?.otzovikMode) {
                                                        const currentUser = getCurrentUserRecord();
                                                        // Если пользователь новый (нет в БД) или у него нет generatedAmounts - генерируем
                                                        if (!currentUser || !currentUser.generatedAmounts) {
                                                            const generated = generateAmountsForTariff(tariff.label, siteSettings);
                                                            if (generated) {
                                                                setPreviewGeneratedAmounts(generated);
                                                                amountsToUse = generated;
                                                            }
                                                        } else {
                                                            // Используем сохраненные generatedAmounts
                                                            amountsToUse = currentUser.generatedAmounts;
                                                        }
                                                    } else if (previewGeneratedAmounts && previewGeneratedAmounts.tariff === tariff.label) {
                                                        // Используем предварительно сгенерированные суммы
                                                        amountsToUse = previewGeneratedAmounts;
                                                    }
                                                    
                                                    handleTariffClick(tariff, amountsToUse);
                                                    setCurrentTariff(tariff.label);
                                                    applyOtzovikTariffAmount(tariff);
                                                }}
                                            >
                                                <TariffDashBorder />
                                                                {isNovaTheme ? <TariffGlyph label={tariff.label} /> : <img src={getTariffIcon(tariff.label)} alt={tariff.label} className={s.tariffIcon} />}
                                                <span className={s.tariffLabel}>{tariff.label.replace(/💰|❗|⚠️/g, '').trim()}</span>
                                    </div>
                                        );
                                    })}
                                </div>
                                
                                {/* Кнопка сохранения пользователя */}
                                <button 
                                    type="button"
                                    className={s.saveUserBtn}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleSaveUser(e);
                                    }}
                                    title="Сохранить юзера"
                                >
                                    <span style={{ marginRight: 8 }}><IconSave /></span>Сохранить юзера
                                </button>
                                {(() => {
                                        const currentUserRecord = getCurrentUserRecord();
                                        const currentCheckpoint = getUserCheckpoint(currentUserRecord || {});
                                        const effectiveSentLog = getEffectiveSentLog(currentUserRecord || {});

                                        const regDisabled = !userEmail || !nameUser || !cryptoAdress ||
                                            (!forceResend && (!currentUserRecord || currentCheckpoint !== 1));
                                        const successDisabled = !userEmail || !nameUser || !cryptoAdress ||
                                            (!forceResend && (!currentUserRecord || currentCheckpoint !== 2));

                                        // Шаг = кнопка отправки + приклеенный снизу статус этого же
                                        // письма (отправлено ли и когда). Единый блок, а не плашка рядом
                                        const renderSendStep = (label, onClick, disabled, st, code) => (
                                            <div className={`${s.sendStep} ${st?.sent ? s.sendStepDone : ''}`}>
                                                <button type="button" className={s.sendStepBtn} onClick={onClick} disabled={disabled}>
                                                    <IconPlane size={15} />
                                                    <span>{label}</span>
                                                </button>
                                                <div className={s.stepStatus}>
                                                    {st?.sent ? (
                                                        <>
                                                            <span className={s.stepStateOk}><IconCheckCircle size={13} /> Отправлено</span>
                                                            <span className={s.stepMeta}>
                                                                <span className={s.stepTime}>{st?.at || ''}</span>
                                                                {code && <span className={s.stepCode}>{code}</span>}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <span className={s.stepStateNo}><span className={s.stepDot} aria-hidden="true" /> Не отправлено</span>
                                                    )}
                                                </div>
                                            </div>
                                        );

                                        return (
                                            <div className={s.sendStepGroup}>
                                                {renderSendStep('Отправить регу', handleSendRegistrationEmail, regDisabled, effectiveSentLog?.registration, effectiveSentLog?.registration?.verificationCode)}
                                                {renderSendStep('Отправить успех', handleSendSuccessEmail, successDisabled, effectiveSentLog?.successFirst)}
                                            </div>
                                        );
                                })()}

                                {/* Регистрация клиента: None (ввод данных) → Пуш (ожидание кода) */}
                                {(() => {
                                    const codeAction = getQuickActionsConfig().find(a => a.key === 'code');
                                    if (!codeAction || !codeAction.enabled) return null;
                                    const record = getCurrentUserRecord() || {};
                                    const checkpoint = getUserCheckpoint(record);
                                    const sentLog = getEffectiveSentLog(record);
                                    const status = sentLog[codeAction.key];
                                    const baseDisabled = (checkpoint < 3) || !userEmail || !nameUser || !cryptoAdress;
                                    const disabledSend = baseDisabled || status?.sent || !codeAction.emailEnabled;
                                    const renderGlyph = () => (
                                        isNovaTheme && !codeAction.isCustom ? (
                                            <ActionGlyph actionKey={codeAction.key} />
                                        ) : typeof codeAction.icon === 'string' && codeAction.icon.startsWith('/') ? (
                                            <img src={codeAction.icon} alt="" className={s.actionIcon} />
                                        ) : (
                                            <span className={s.actionIcon} style={{ fontSize: '24px' }}>
                                                {codeAction.icon || '📝'}
                                            </span>
                                        )
                                    );
                                    return (
                                        <div className={s.stepBlock} style={{ marginTop: 10 }}>
                                            <div className={`${s.actionCard} ${s.actionSplit}`}>
                                                <div
                                                    className={s.actionHalf}
                                                    onClick={() => setShowCodeInputModal && setShowCodeInputModal(true)}
                                                >
                                                    {renderGlyph()}
                                                    <span className={s.actionLabel}>Рега</span>
                                                </div>
                                                <div
                                                    className={s.actionHalf}
                                                    onClick={() => setShowCodeModal && setShowCodeModal(true)}
                                                >
                                                    {renderGlyph()}
                                                    <span className={s.actionLabel}>Пуш</span>
                                                </div>
                                            </div>
                                            {codeAction.emailEnabled && (
                                                <div className={`${s.stepSend} ${status?.sent ? s.stepSendDone : ''}`}>
                                                    <button
                                                        className={s.stepSendBtn}
                                                        title="Отправить письмо"
                                                        disabled={disabledSend}
                                                        onClick={() => handleSendActionEmail(codeAction.key)}
                                                    >
                                                        <IconPlane size={14} />
                                                        <span>Отправить</span>
                                                    </button>
                                                    <div className={s.stepStatus}>
                                                        {status?.sent ? (
                                                            <>
                                                                <span className={s.stepStateOk}><IconCheckCircle size={13} /> Отправлено</span>
                                                                <span className={s.stepMeta}><span className={s.stepTime}>{status?.at || ''}</span></span>
                                                            </>
                                                        ) : (
                                                            <span className={s.stepStateNo}><span className={s.stepDot} aria-hidden="true" /> Не отправлено</span>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>
                    </div>

                    {/* Bank Configuration section removed: controls embedded into User Data */}

                    

                    {/* Main Sections Layout */}
                    <div className={s.mainSections}>
                        {/* Quick Actions */}
                        <div className={s.sectionVertical}>
                            <h3 className={s.sectionTitle}>
                    <SectionGlyph icon={Zap} png={quickActionsIcon} alt="Quick Actions" />
                    Вторая линия
                </h3>
                            
                            <div className={s.actionList}>
                                {(() => {
                                    // «code» (None/Пуш) живёт в блоке «Данные»
                                    const actions = getQuickActionsConfig().filter(a => a.key !== 'code');
                                    const record = getCurrentUserRecord() || {};
                                    const checkpoint = getUserCheckpoint(record);
                                    const sentLog = getEffectiveSentLog(record);
                                    const baseDisabled = (checkpoint < 3) || !userEmail || !nameUser || !cryptoAdress;
                                    const firstNotSentIndex = actions.findIndex(a => a.enabled && !(sentLog[a.key]?.sent));
                                    return actions.map((actionConfig, index) => {
                                        const status = sentLog[actionConfig.key];
                                        const orderedDisabled = (firstNotSentIndex !== -1 && index !== firstNotSentIndex);
                                        const disabledSend = baseDisabled || status?.sent || !actionConfig.enabled || orderedDisabled || !actionConfig.emailEnabled;
                                        
                                        return (
                                        <div key={actionConfig.key} className={`${s.stepBlock} ${!actionConfig.enabled ? s.stepBlockDisabled : ''}`}>
                                            <div 
                                        className={`${s.actionCard} ${!actionConfig.enabled ? s.actionCardDisabled : ''}`}
                                        onClick={actionConfig.enabled ? () => {
                                            console.log('🚀 AdminPanel: Clicked action (mobile):', actionConfig.key);
                                            if (actionConfig.action) {
                                                actionConfig.action();
                                            }
                                        } : undefined}
                                                style={{ cursor: actionConfig.enabled ? 'pointer' : 'not-allowed', opacity: actionConfig.enabled ? 1 : 0.5 }}
                                            >
                                                {isNovaTheme && !actionConfig.isCustom ? (
                                                    <ActionGlyph actionKey={actionConfig.key} />
                                                ) : typeof actionConfig.icon === 'string' && actionConfig.icon.startsWith('/') ? (
                                                <img src={actionConfig.icon} alt={actionConfig.name} className={s.actionIcon} style={{ filter: !actionConfig.enabled ? 'grayscale(100%)' : 'none' }} />
                                                ) : (
                                                    <span className={s.actionIcon} style={{ fontSize: '24px', filter: !actionConfig.enabled ? 'grayscale(100%)' : 'none' }}>
                                                        {actionConfig.icon || '📝'}
                                                    </span>
                                                )}
                                        <span className={s.actionLabel}>{actionConfig.name}</span>
                                    </div>
                                            {actionConfig.emailEnabled && (
                                            <div className={`${s.stepSend} ${status?.sent ? s.stepSendDone : ''}`}>
                                                <button
                                                    className={s.stepSendBtn}
                                                    title="Отправить письмо"
                                                    disabled={disabledSend}
                                                    onClick={() => handleSendActionEmail(actionConfig.key)}
                                                >
                                                    <IconPlane size={14} />
                                                    <span>Отправить</span>
                                                </button>
                                                <div className={s.stepSendStatus}>
                                                    {status?.sent ? (
                                                        <>
                                                            <span className={s.stepTime}>{status?.at || ''}</span>
                                                            <span className={s.stepStateOk}><IconCheckCircle size={13} /> Отправлено</span>
                                                        </>
                                                    ) : (
                                                        <span className={s.stepStateNo}><span className={s.stepDot} aria-hidden="true" /> Не отправлено</span>
                                                    )}
                                                </div>
                                            </div>
                                            )}
                                        </div>
                                        );
                                    });
                                })()}
                            </div>
                        </div>

                        {/* Transaction Management */}
                        <div className={s.sectionVertical}>
                            <h3 className={s.sectionTitle}>
                        <SectionGlyph icon={ArrowLeftRight} png={transactionsIcon} alt="Transactions" />
                        Транзакции
                    </h3>
                            
                            <div className={s.transactionList}>
                                <button
                                    className={`${s.transactionBtn} ${s.add}`}
                                    onClick={addTransaction}
                                >
                                    {isNovaTheme ? <Plus size={15} strokeWidth={2.4} aria-hidden="true" /> : <img src={addButtonIcon} alt="Add" className={s.buttonIcon} />}
                                Добавить
                                </button>
                                
                                <button
                                    className={`${s.transactionBtn} ${s.remove}`}
                                    onClick={removeTransaction}
                                >
                                    {isNovaTheme ? <Minus size={15} strokeWidth={2.4} aria-hidden="true" /> : <img src={removeButtonIcon} alt="Remove" className={s.buttonIcon} />}
                                Удалить
                                </button>
                            </div>

                            <div className={s.transactionInfo}>
                                <div className={s.infoItem}>
                                    <span className={s.infoLabel}>Всего:</span>
                                    <span className={s.infoValue}>{transactions.length}</span>
                                </div>
                                <div className={s.infoItem}>
                                    <span className={s.infoLabel}>Сумма:</span>
                                    <span className={s.infoValue}>{currencyFormat || 'RM'} {maxTotalMoney.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                                </div>
                            </div>
                        </div>

                        {/* Custom Values */}
                        <div className={s.sectionVertical}>
                            <h3 className={s.sectionTitle}>
                        <SectionGlyph icon={Wallet} png={customValuesIcon} alt="Custom Values" />
                        Кастомный кэш
                    </h3>
                            
                            <div className={s.customList}>
                                <div className={s.fieldGroup}>
                                    <label className={s.fieldLabel}>Выигрыш (в {currencyFormat || 'RM'})</label>
                                    <input
                                        type="number"
                                        className={s.input}
                                        value={customMaxMoney}
                                        onChange={(e) => setCustomMaxMoney(e.target.value)}
                                        placeholder="Сумма выигрыша"
                                    />
                                </div>

                                <div className={s.fieldGroup}>
                                    <label className={s.fieldLabel}>Депозит (в {currencyFormat || 'RM'})</label>
                                    <input
                                        type="number"
                                        className={s.input}
                                        value={customDepositMoney}
                                        onChange={(e) => setCustomDepositMoney(e.target.value)}
                                        placeholder="Сумма депозита"
                                    />
                                </div>
                            </div>

                            <button 
                                className={s.applyBtn}
                                onClick={() => {
                                    // Полный расчет как в handleTariffClick с кастомными значениями
                                    const customBaseAmount = Number(customMaxMoney) || 0;
                                    const customDepositAmount = Number(customDepositMoney) || 0;
                                    
                                    if (customBaseAmount > 0 && calculateCryptoAmount && handleUpdateValues) {
                                        // Рассчитываем количество выбранной криптовалюты
                                        const cryptoAmount = calculateCryptoAmount(customBaseAmount, selectedCrypto);
                                        
                                        // Применяем все значения через handleUpdateValues (как в оригинальных тарифах)
                                        handleUpdateValues(
                                            customBaseAmount,     // maxTotalMoney (выигрыш пользователя)
                                            customDepositAmount,  // depositMoneyHistory (депозитная сумма) 
                                            parseFloat(cryptoAmount), // bnbBalance (количество крипты)
                                            0  // fee (комиссия, пока 0)
                                        );
                                        
                                        // В обычном режиме (не отзовик) устанавливаем сумму для модала успеха
                                        if (!siteSettings?.otzovikMode && setVerifyModalAmount) {
                                            setVerifyModalAmount(customBaseAmount);
                                        }
                                        
                                        console.log('🎯 Применены кастомные значения с полным расчетом:', {
                                            выигрыш: customBaseAmount,
                                            депозит: customDepositAmount,
                                            криптовалюта: selectedCrypto,
                                            количествоКрипты: cryptoAmount,
                                            курс: siteSettings.cryptoRates[selectedCrypto]
                                        });
                                    } else {
                                        console.warn('⚠️ Некорректные значения или отсутствуют функции расчета');
                                    }
                                }}
                            >
                                Применить значения
                            </button>
                        </div>


                    </div>
                                </>
                            );
                        }
                    })()}
                </div>
            </div>
            {renderSaveDialog()}
        </div>
        </>
    );

    if (isNovaTheme && typeof document !== 'undefined') {
        const novaRoot = document.querySelector('[data-nova-theme]');
        if (novaRoot) {
            return ReactDOM.createPortal(panelNode, novaRoot);
        }
        // Корень Nova ещё не смонтирован (тема только что переключилась):
        // не рендерим панель без её CSS-токенов, иначе она будет прозрачной.
        // Эффект ниже дождётся появления корня и перерендерит компонент.
        return null;
    }

    return panelNode;
}; 
